export const _MiscMessages = {
  FrontendError: "Frontend Error",
  TitleNotSet  : "*** NO TITLE SET ***",
  ValueNotSet  : "*** NO VALUE SET ***",
}

export const _MustMatchServerStrings = {
  //CRN_20251217 - ⚠️ Make a change here reflect on server ⚠️

  HiddenValue               : "Hidden Value",
  HiddenValueCanOverwrite   : "Hidden Value - although new value can be submitted",
  SmsOnlyTemplateSubject    : "NOT SET AS SMS Only Template",
  SourceSystemCommunications: "Communications",
  SourceSystemLegacySms     : "LegacySms",
}

export const AccessGuids = {
  AnimationSureSimContainerGrowGuard               : "D9260E34-C90D-4032-A711-AAED9BA0A66C",
  AnimationSureSimLogoGrowGuard                    : "AB307E8C-9707-4ABD-AC67-6EE10A18713A",
      
  ChargeableFeatureAlertsCountryPlans              : "5F644759-B29B-4015-BA3E-5938861DDB28",
  ChargeableFeatureApplicationSummaries            : "DE834F1E-7A6C-4A22-BD44-595D1C4FC8C9",
  ChargeableFeatureChatGpt                         : "5019B148-6BAD-40E5-BAF5-02DEC6F4D0D3",
  ChargeableFeatureDeviceManagement                : "9135AB50-DC82-4304-919B-4E0D5026F865",
  ChargeableFeatureDeviceManagementHealthReport    : "C277F125-B84F-4910-8D03-22AFE2D1AC48",
  ChargeableFeatureLocationServices                : "2D180A6D-F7F1-4A88-9787-E5972FF21D67",
  ChargeableFeatureLocationWebhook                 : "B6F3A9C2-7D14-4E85-A0B9-3C2E1F5D8A47",
  ChargeableFeatureMessagingApi                    : "E4B9C1A6-7F52-4D38-B1E0-6A3C9D28F5B7",
  ChargeableFeatureRiskIntelligence                : "E9D7F4B2-3C8A-4615-9B27-1D8F6C5A4E03",
  ChargeableFeatureSignals                         : "7B4E92AC-16D3-4F80-A5C7-E38B0D6194F2",
  ChargeableFeatureSingleSignOn                    : "8C3B6316-7903-469B-946E-87D047CACB90",
  ChargeableFeatureTravelAwareness                 : "F1C4A2E8-6B39-4D57-A8E0-9C3B1D6F5A24",
   
  DashboardInventoryLucyShowFirstCallStatus        : "3DF27929-57DD-4EEB-BECD-D1C33C3D2087",
  
  DashboardShowCompanyForUserGuard                 : "03A462BC-2FA1-41EF-B46A-6E3551B85536",
  DashboardShowUsageDashboard                      : "A5BEF8D6-4DF0-4BFD-9F59-22B355D79EDC",
  DashboardTopUsersShowTag                         : "47836D78-68A1-4231-9598-70621CF419E7",
  DashboardTopUsersShowTag2                        : "4DA5308D-934D-45B1-8345-F24C51AB7DBD",

  DashboardTravelRiskToggleDataSource              : "3F8D6B2A-5C19-4E74-B0A8-7D2F1C6E94B3",
   
  DemoShowDemoItems                                : "56DD8CAD-A204-4881-B787-46060F550E48",
      
  DropdownsCompanyHierarchyExpand                  : "FFCDC02A-840B-462E-B2CB-9113358149BA",
  DropdownsCompanyHierarchyGuard                   : "213658DD-8919-4A97-B572-3E4A0FF24C43",
  DropdownsCompanyShowAtTopFirst                   : "70F22FEC-223C-4806-AF0C-424BA8FFFBA0",
  DropdownsCompanyTopLevelSelect                   : "398B6568-A3DF-4099-B155-61DEDA1577A5",
  DropdownsTrackingCompanyId                       : "447F989E-9A3D-45D8-BF59-A838723A4B32",
      
  FormApiManagement                                : "A7D2F5C9-3B14-4E68-9A0D-2C7F81B4E6A3",
  FormAlertAdminSwitches                           : "8B8B8F50-D420-40A2-BA2F-0458B41922C6",
  FormChatGptAllowAskAnything                      : "2E274C4D-2773-4B4E-84D9-068A788176B9",
  FormCommunicationMessageBaseWide                 : "4433A9C2-15B0-4CAB-BECA-23AD2BFAEBA2",
  FormCommunicationShowSmsProviderOverride         : "9E5A1C3B-7D42-4F88-A6E1-2B0C5D9F4A71",
  FormCompaniesGenerateStatement                   : "D9A4F1C7-6B23-4E85-9F02-3C7A1D6E8B54",
  FormCompaniesGenerateStatementsBulk              : "A3F7E2C9-8D14-4B60-9E5A-7C2140F9D6B3",
  FormCompaniesViewStatement                       : "E1C8B3D6-4F92-4A57-8B10-2D6F9A3C7E41",
  FormCompaniesViewStatementHistory                : "BD7150A1-4E6E-4A7A-BC24-3B6B6E3BD3CD",
  FormCompanyCease                                 : "C3A7F1E2-9D46-4B58-A1C0-7E4D2F6B8A31",
  FormCompanyCreateTestAccounts                    : "C2016D8D-E632-4294-8C3C-6C674DD84538",
  FormCompanyDesensitiseMdm                        : "0AD383B1-87A4-4E0A-9CEA-3FC6EBBE0B10",
  FormCompanyDropdownShowAtTop                     : "1B836ADB-35C3-4F71-918F-ACCF93862A47",
  FormCompanyInventoryOrgId                        : "EDCD1E6E-12CC-4DBF-A386-424EDBDA9918",
  FormCompanySetCreateSubCompanyOnAdd              : "6F78C4FF-356C-4F32-A28C-C5FD5E3755F6",
  FormCompanyShowAlerts                            : "A0DBB758-DA8F-4029-9B51-6917CAA5A337",
  FormCompanyShowDeviceManagement                  : "99A0D8EA-4F70-41E6-85C8-90C8319C1D8E",
  FormCompanyShowLicenceDetails                    : "E01AE82E-BD6A-4C75-8F1A-0C64D5572C72",
  FormCompanyShowSingleSignOn                      : "7304A2A8-EED2-4432-9EA6-B4B0FEFF6A98",
  FormCompanyShowSpendLimits                       : "919CC56D-39A3-405A-9718-DF6FD8FD4C93",
  FormCompanyStatementLogo                         : "7B4E2D91-C68F-4A03-B5D7-1E9042C8F3A6",
  //FormCompanyUncease                               : "D5B8A2F3-1E57-4C69-B2D1-8F5E3A7C9B42", //CRN_20261021 - Retired
  FormGeneralLastPassKillerGuard                   : "AA218B66-9FD5-4351-A950-CA6F71B59BDF",
  FormLocationWebhookReplayLastCountryChange       : "3D8E6B14-9A25-4C73-8F60-5B2A7E4D1C89",
  FormManageSIMShowAlerts                          : "1B98D2E7-03FA-4B34-8B91-5AED9AF59F1B",
  FormManageUserEntitlements                       : "B8E3F1A6-4D72-4C9E-A5B1-2F7C6D3E8A94",
  FormPartnerClientLinks                           : "C4D9F6A2-3B81-4E57-9A2D-6F0B8C1E5D74",
  FormProvisionBulkCreateUsersButton               : "C3F5EAF9-4D16-4F83-A027-5E9C1D3F8B64",
  FormProvisionBulkProvisionButton                 : "3B5ECDAE-D2FD-4840-9F7B-C871BE40E46D",
  FormProvisionBulkReserveSimsButton               : "A1F3C8E7-2B94-4D61-8E05-3C7A9B1D6F42",
  FormProvisionBulkRetireInviewClisButton          : "B2E4D9F8-3C05-4E72-9F16-4D8B0C2E7A53",
  FormProvisionManualProvisionButton               : "949FF8D9-C575-4694-8B56-899927D0900C",
  FormProvisionReservationButtons                  : "B9BAF78A-5FA0-4281-A639-9E920DD848BC",
  FormSupportPage                                  : "A7E4C1D9-2B85-4F63-9C07-6D3E1A8B5F42",
  FormSupportPageCompanyDropdown                   : "B8F5D2EA-3C96-4A74-8D18-7E4F2B9C06A5",
  FormTripReadyShowModeToggle                      : "2EF18A13-9E46-4BE3-8418-595A77B36295",
  FormUserAccessTypeSuperUserSelectionAllow        : "912DC3E2-10E1-4DD5-BE71-B488C4751118",
  FormUserChangeUserRole                           : "A62A2112-27F2-4A01-8271-B3C6EA759D54",
  FormUserReset2FaButton                           : "A64D0500-4FC6-4643-83C9-A72F631C3B60",
  FormUserResetPasswordButton                      : "4F6FEA7B-13D3-43BE-AD04-36EE70BEE69E",
  FormUserShowUsernameAndMobileWhenDevice          : "074F357E-45D6-47EB-9457-4465F1C9A90D",
   
  GridCreditLimitManagementShowManualTriggerButtons: "04329FB5-24FE-4ECA-A1D8-E5EEE78916A6",
  GridDevicesAllocatedBulkActions                  : "B7E1B3A2-4C9D-4E88-9F2A-6D3C1E7A5B44",
  GridMdmDevicesCompanyShowSyncButton              : "F06C036A-0072-4E22-B00E-7FF9AAC2B80E",
  GridMdmDevicesIntuneShowImportButton             : "DE4F6219-A414-413C-B03B-E35A6738F9EC",
  GridMdmDevicesIntuneShowSyncButton               : "3C96315C-635F-42CD-9587-188F70FCF042",
  GridMdmDevicesRemediationEnableRunButtons        : "B642B60E-B48E-49FE-94B6-F2995E0D2A91",
  GridMdmUsersIntuneShowImportButton               : "70B3EB73-1E35-456F-A0B7-31DE321DB3B1",
  GridMdmUsersIntuneShowSyncButton                 : "1B58528E-E5D9-4FC1-A52F-6CAFC29ECAA9",
  GridMessagingIncludeLegacySms                    : "B7F3E2A1-9C4D-4E6F-A1B2-3C5D7E9F0A2B",
  GridNetworkEventsCellInfoShow                    : "9F92220E-75CB-41D8-9D8B-7CEB38328BF8",
  GridScreenDefaultsBase                           : "E4B9C7A1-5F3D-4A28-9C6E-1B0D2F8A3E57",
  GridScreenDefaultsCompanyActual                  : "D820F403-1B76-40AC-B965-6A1921C4DDEA",
  GridScreenDefaultsUserActual                     : "275FDC9F-1F7C-4631-B659-EFB2556D1981",
  GridCompaniesShowCeased                          : "E7C9B3A4-2F68-4D7A-C3E2-9A6F4B8D1C53",
  GridCompaniesShowDeleted                         : "C7E9A1F4-2B3D-4E5A-9C6F-8D0A1B2C3D4E",
  GridShowAll                                      : "24DBDB21-7014-439D-95FC-E40A2636796B",
  GridShowFiltersByDefault                         : "1D8587B6-74CA-4D39-A85D-615F307D109E",
  GridUserEsimBulkActions                          : "A413A8A4-5BCF-4009-A948-6745AAC16821",
  GridUserEsimTransferUser                         : "CE32AA57-D720-4E7F-8635-4052E691FF00",
  GridUserEsimTransferUserData                     : "4556EED7-99A1-4328-A8EA-346CB8F36870",
  GridUsersShowDeleted                             : "42C27331-81DA-4B2B-902C-1D6F69837666",

  LicencesAdminKey                                 : "1923E65A-2F5F-483E-8ED2-1ADB3B58E179",
  LicencesEditBilledOverride                       : "1E3DB114-AB76-4738-9ADD-EF6101FFCF22",
   
  LocationAwarenessHomeTrackingGuard               : "D6678725-F003-4A6B-803D-91D4884B9147",
  LocationAwarenessUserOptIn                       : "427BFACC-9B0E-4700-8300-8C4114D9494D",
  LocationAwarenessViewFailedLocations             : "856E7F50-DA18-4593-9334-F72994A9D0A9",
  LocationServicesEditSettings                     : "A1E7C3F4-9B62-4D58-AE31-2C7F0B9D6E85",
  LocationServicesMapSettings                      : "C7A4E2B9-1F6D-4A3E-8B52-9D0C3E7F1A64",
   
  LoginCookieWarningSuppress                       : "FB566BF8-C2AB-4BFA-8C73-599592B31BD5",
  LoginOrLogoutAutoLogoutGuard                     : "D80EC072-CB4C-4B2F-A920-B07E63C26B8E", //CRN_20250929 - Example 💡 - !WebComponent.AutoGrantHighAccessUser
      
  MdmDashboardShowImportButton                     : "4EAF0A44-60CA-4ED1-97FE-D479D250800F",
  MdmDashboardShowPdfExportButton                  : "AB1C4ABE-E9CB-4D41-B2A0-967684C67065",
  MdmDashboardShowSyncButton                       : "F38C457A-FE90-43CD-97FE-DFE1A7778631",
      
  MenuItemAvailableSims                            : "923066C5-24F3-4CFC-BB67-B944DDA8FD20",
  MenuItemBulkProvision                            : "C7A4E9B2-3D61-4F8C-9A5E-2B7D0C1F8E63",
  MenuItemCommConfig                               : "EDF45CE8-9C98-4F7F-8321-98BC17740872",
  MenuItemConfig                                   : "A4B7778D-F332-47DB-8123-B724DA3CF7E5",
  MenuItemConfigComponents                         : "A72C27C2-B025-4094-AF28-C1F1B28EF00A",
  MenuItemConfigCountryGroups                      : "34052C67-6C85-495F-AB8A-2D2EA5EFEF3A",
  MenuItemConfigLicences                           : "80335096-754F-4F49-9CCD-AD0B4A4C7C16",
  MenuItemConfigLicencesCompanyAllocated           : "64F7A4DA-9DA7-4C01-A540-460A2BF4EF60",
  MenuItemConfigLicencesCompanyVisible             : "8465F950-D368-4D1D-A92A-C6BCCAAFD408",
  MenuItemConfigLicencesSystem                     : "24C33FBA-CEC0-4267-B861-83CA26DEEDD2",
  MenuItemConfigMapping                            : "301533CC-AA33-4C2E-B476-E3DB897781A0",
  MenuItemConfigMdmDevices                         : "C8473A2A-0B1E-416A-BBE5-C1AE165A7143",
  MenuItemConfigProducts                           : "529951D7-C3EF-4668-910B-EFBE19017049",
  MenuItemConfigReports                            : "CA5A2A51-D80F-4D15-AB36-22E16B039CD3",
  MenuItemConfigScreenDefaults                     : "E2C6B531-EADE-4564-A8E7-55DECF0713F4",
  MenuItemConfigSystem                             : "0A5A8B01-240C-4CB9-9695-FFA8462093A0",
  MenuItemConfigTypes                              : "7C51EE1C-5828-4216-B14A-3F10163D340A",
  MenuItemInventory                                : "3CD04811-DA9A-4EB0-9BC0-2BA897BE97BA",
  MenuItemInvoice                                  : "08C7B1BF-18E8-4A13-A7CC-0ED46012A846",
  MenuItemLocalRiskLevels                          : "A1B7C8D2-9F4E-4B5A-8C3D-2E6F1A4B8C9D",
  MenuItemLocationServices                         : "04028375-E90B-4567-9F22-CD04B144235A",
  MenuItemMdmDeviceCampaigns                       : "E341CC01-1773-459D-881A-077F0CBCE109",
  MenuItemMdmDeviceRemediation                     : "6FC539FB-D616-47E3-B1A4-9D23FB29DD1B",
  MenuItemMdmDevicesAll                            : "3E7C1D95-4A82-4B6F-9C08-B5D71E2A6F43",
  MenuItemMdmDevicesCompany                        : "61AB05AB-9383-43D8-B658-A5B10D89B7FB",
  MenuItemMdmDevicesCompanyConfig                  : "7C3D3F04-EEE5-478C-ADA1-D3F9F15857DF",
  MenuItemMdmDevicesTemplatesCampaigns             : "AFD1EAF6-82B8-4371-BC51-3D745A6E4EEC",
  MenuItemMdmDevicesTemplatesRemediation           : "65FEB226-F3F1-4FE0-955B-AF33702115C8",
  MenuItemMdmDevicesTemplatesRemediationToStatus   : "1A689F63-A210-408B-AE05-95D54BD6A1D2",
  MenuItemMdmDeviceUsers                           : "AA402B28-79EE-478A-B3F6-AE0B708163AC",
  MenuItemMdmIntuneSimExceptions                   : "B7F4E2A9-3C61-4D08-9E52-1A6F8C0D4B37",
  MenuItemMessaging                                : "1616AFC4-90A7-4670-8FF9-BF7A495FD809",
  MenuItemReports                                  : "ACD146EB-463C-4C35-B614-BE75425B5D92",
  MenuItemRiskManagement                           : "A386A72F-7659-4ED1-B180-AA4A154D6D5C",
  MenuItemRiskManagementTravelRisk                 : "C5A8E3F1-9D26-4B70-8A14-3E7C2F6D0B95",
  MenuItemSignals                                  : "2F86D410-B7C5-4E39-90A8-5D1C7E4B36F0",
  MenuItemSignalsBreachExposure                    : "6C0B5A83-D291-4E7F-8B36-1A94E2D50C78",
  MenuItemSignalsCorporateHealth                   : "9E4A1F72-5C08-4B6D-A3E1-7F209C8B4D53",
  MenuItemSignalsDashboard                         : "B85D3C09-4A16-42F7-9E80-C6371D5A29E4",
  MenuItemSignalsDeviceVulnerabilities             : "43F7E28B-1D64-4C05-B9A2-8E50D3617FC9",
  MenuItemSignalsTravelRisk                        : "19403900-C094-4843-8FF3-87F548D97A30",
  MenuItemSignalsTravelRiskAdvisories              : "0BD8F94E-8BE9-4C75-B9EE-86B9160572C4",
  MenuItemSignalsTravelRiskAlerts                  : "6BE48ADF-ECFF-48D2-A2F8-A1579F768FC0",
  MenuItemSignalsTravelRiskCityReports             : "E98885BC-7177-4FD9-9BDA-89369ABD1D46",
  MenuItemSignalsTravelRiskComparison              : "E89CA222-2C0D-4BFD-BB65-E8A114413324",
  MenuItemSignalsTravelRiskCountryReports          : "339E323B-B41D-47CE-BBD4-926092DC1029",
  MenuItemSignalsTravelRiskCountryRiskLevels       : "09930540-4B7C-4B12-AB85-671108A11EDE",
  MenuItemSignalsTravelRiskExposure                : "030831F7-E3B5-422E-AB3D-ECC381CE4D5B",
  MenuItemSignalsTravelRiskTripBrief               : "9450C320-976A-4748-A89E-23D62B349356",
  MenuItemSupplier                                 : "76E18C60-D5C1-4A7C-9201-D7F47554B32C",
  MenuItemSupplierSuppliers                        : "669B62A3-3BD6-455C-8D5C-61D27750E0B5",
  MenuItemSystemAdmin                              : "9C965584-E89C-4C4A-812C-437499E67090",
  MenuItemSystemAdminAudit                         : "368FDEB0-AA90-47B0-9748-6D38F9D44944",
  MenuItemSystemAdminApiManagement                 : "C3F8A2D5-9B41-4E76-A1C8-5D2F7B93E4A6",
  MenuItemSystemAdminCreditLimitAlertRecipients    : "144CC236-77AD-40E6-AA02-2A340396D57A",
  MenuItemSystemAdminCreditLimitManagement         : "FB2645AD-EA2B-4EA6-A368-26A9A69D4FD5",
  MenuItemSystemAdminCreditLimits                  : "A1903092-4915-45EB-961A-2678312581D3",
  MenuItemSystemAdminOverview                      : "CAEF2BDD-894B-4777-81A8-5FC4B61299C5",
  MenuItemSystemAdminPlatformInsights              : "15FCEA32-B61C-495C-B9BD-53DBBEFD2740",
  MenuItemSystemAdminSMSAudit                      : "81B204BB-882F-4A5A-85B0-3C53E3061CDD",
  MenuItemSystemAdminSystemLocks                   : "1E0F92E8-587C-4F89-BC2E-31B2AEBC5259",
  MenuItemSystemAdminTeams                         : "ADCB24C8-617D-4A2C-80A0-D1AAA7E831C4",
  MenuItemSystemAdminTeamsStatuses                 : "A026D89A-1AAD-434E-978C-91584518E0C5",
  MenuItemSystemAdminTeamsStatusesManualSync       : "DD4715C5-B5E9-4540-AD74-014091E6E9A6",
  MenuItemSystemAdminTransferUserSims              : "A622991C-55BC-4DA8-B171-1506E71CF2A8",
  MenuItemSystemAdminTriggeredAlerts               : "7F3C1A9E-4B2D-4E88-9C1A-2D5E6F7A8B90",
  MenuItemSystemAdminUnresolvedMobile              : "C7E3A1F4-2D9B-4E6C-8A05-3F1B6D8E2A47",
  MenuItemSystemAdminUser                          : "5441933C-13A4-4C1A-BDD7-76850BEF2144",
  MenuItemSystemAdminUserBrowserInfo               : "CDBEEEE1-DB51-43C2-846F-0B6487F5A1EA",
  MenuItemSystemAdminUserClientInfo                : "43389D8D-DF53-4090-BDA1-0E14B4427E31",
  MenuItemSystemAdminUserSessions                  : "486B5CFB-028A-45A4-80AF-5ED41BD83406",
  MenuItemTariffs                                  : "0BE1A36F-D3ED-4FDF-82F4-5B5C0294068A",
  MenuItemTariffsRental                            : "2FF53E62-FF53-47CD-8D6B-90F7CA780599",
  MenuItemTariffsUsage                             : "E6C4AEFC-2BBA-43E8-AC47-ABAB4A69C45A",
  MenuItemTravelSearch                             : "D4E5F6A7-3B2C-4E1D-9F8A-7C6B5D4E3F2A",

  ReportAuditSummary                               : "3F81C29D-6A47-4B15-9E0C-52D7B48A16F3",
  ReportFinancialCostSummary                       : "7B4E9A16-2C58-4D03-A9F7-6E1B3D8C5042",

  SupportHelpCreateMenuItems                       : "DC51732D-9038-40EE-8050-8EFE435952C3",
  SupportHelpHtmlAuthor                            : "9787B912-D81A-4D0D-9B5B-39D983052DFE",
  SupportHelpRenameMenuItems                       : "76FC6B01-3135-4F59-A9A9-483F3EF2E05A",
  SystemOwnedBypass                                : "8B1F0C6D-4E27-4A93-9D5C-2F7A6E1B0C84",

  TopBarShowChatGpt                                : "63429087-50E3-4C5B-A0B2-6DE999338ED6",
  TopbarShowCompanyForUserGuard                    : "C83E5676-E220-4F2A-B53B-54FF3CD40052",
  TopBarWorldClockHideFlags                        : "B5F2C3A1-7E4D-4D9F-9C1A-6F0E2B8D4A11",
}

export const AlertClassColour = {
  Green : "alert-success",
  Grey  : "alert-primary",
  Red   : "alert-danger",
  Yellow: "alert-warning",
}

export const ApplicationNames = {
  ApplicationTitle_Platform     : "Management Platform",
  ApplicationTitle_SureSimPortal: "SIM Management Portal",
  ChatGPT                       : "ChatGPT",
  eSimPlatform                  : "SureSIM Portal",
  InviewApi                     : "Inview",
  InviewPortal                  : "Inview Portal",
  SureSIM                       : "SureSIM",
}

export const ConfigSystemParams = {       
  AddAssociateUserExcludeSureSimUsers                               : "AddAssociateUserExcludeSureSimUsers",
  AddCompanyExcludeSureSimCompanies                                 : "AddCompanyExcludeSureSimCompanies",
  AddEsimUserExcludeSureSimUsers                                    : "AddEsimUserExcludeSureSimUsers",
  AddPortalUserExcludeSureSimUsers                                  : "AddPortalUserExcludeSureSimUsers",
  AdminOverviewCollapseContainers                                   : "AdminOverviewCollapseContainers",
  AdminOverviewColumnHeadersShort                                   : "AdminOverviewColumnHeadersShort",
  AdminOverviewCompanyTopLevelSelect                                : "AdminOverviewCompanyTopLevelSelect",
  AdminOverviewContainerCloseAllow                                  : "AdminOverviewContainerCloseAllow",
  AdminOverviewLiveBarredOnly                                       : "AdminOverviewLiveBarredOnly",
  AdminOverviewTitleShowHintText                                    : "AdminOverviewTitleShowHintText",
  AlertingHidePWA                                                   : "AlertingHidePWA",
  ApiVersion                                                        : "Version",
  AuditLastPurgeDate                                                : "AuditLastPurgeDate",
  AuditPageViewsEnabled                                             : "AuditPageViewsEnabled",
  AutoHideToast                                                     : "AutoHideToast",
  AutoLogoutDivertAllToLoginForm                                    : "AutoLogoutDivertAllToLoginForm",
  AutoLogoutEnabled                                                 : "AutoLogoutEnabled",
  AutoLogoutMilliSecs                                               : "AutoLogoutMilliSecs",
  ChatGptAliasFull                                                  : "ChatGptAliasFull",
  ChatGptAliasShort                                                 : "ChatGptAliasShort",
  ChatGptAllowAskAnything                                           : "ChatGptAllowAskAnything",
  ChatGptPulseResponseArea                                          : "ChatGptPulseResponseArea",
  ChatGptRetainSessionHistory                                       : "ChatGptRetainSessionHistory",
  ChatGptShowExplainability                                         : "ChatGptShowExplainability",
  ChatGptShowInsights                                               : "ChatGptShowInsights",
  ChatGptShowStageStrip                                             : "ChatGptShowStageStrip",
  ChatGptUseAzureOpenAi                                             : "ChatGptUseAzureOpenAi",
  CommunicationSmsTwilioEnabled                                     : "CommunicationSmsTwilioEnabled",
  CommunicationTemplatesHideFromOptions                             : "CommunicationTemplatesHideFromOptions",
  CommunicationTemplatesImeiLockingText                             : "CommunicationTemplatesImeiLockingText",
  CommunicationTemplatesProvisionViaEmailText                       : "CommunicationTemplatesProvisionViaEmailText",
  CommunicationTemplatesProvisionViaManualText                      : "CommunicationTemplatesProvisionViaManualText",
  CommunicationTemplatesProvisionViaSMSText                         : "CommunicationTemplatesProvisionViaSMSText",
  CommunicationTemplatesShowTestMessageButton                       : "CommunicationTemplatesShowTestMessageButton",
  CommunicationTemplatesUseSupplierMessaging                        : "CommunicationTemplatesUseSupplierMessaging",
  CompaniesStatementsEnabled                                        : "CompaniesStatementsEnabled",
  CookieRememberIsSso                                               : "CookieRememberIsSso",
  CookieRememberMeExpiryDays                                        : "CookieRememberMeExpiryDays",
  CountriesDefault                                                  : "CountriesDefault",
  CountriesUseAlias                                                 : "CountriesUseAlias",
  CreditLimitsCompanyEnabled                                        : "CreditLimitsCompanyEnabled",
  DashboardActivityEnabled                                          : "DashboardActivityEnabled",
  DashboardChangeTitleDelay                                         : "DashboardChangeTitleDelay",
  DashboardChangeTitles                                             : "DashboardChangeTitles",
  DashboardChartsVersion20251023                                    : "DashboardChartsVersion20251023",
  DashboardContainerCloseAllow                                      : "DashboardContainerCloseAllow",
  DashboardDonutCostsPerZoneWidth                                   : "DashboardDonutCostsPerZoneWidth",
  DashboardGridLinksInBlue                                          : "DashboardGridLinksInBlue",
  DashboardGridUserInteractiveEnabled                               : "DashboardGridUserInteractiveEnabled",
  DashboardShowActivityOnStart                                      : "DashboardShowActivityOnStart",
  DashboardShowCompanyForUser                                       : "DashboardShowCompanyForUser",
  DashboardShowCostsPerZone                                         : "DashboardShowCostsPerZone",
  DashboardShowCostsPerZoneIfNoData                                 : "DashboardShowCostsPerZoneIfNoData",
  DashboardShowDateSelector                                         : "DashboardShowDateSelector",
  DashboardShowDateSelectorViaIconClick                             : "DashboardShowDateSelectorViaIconClick",
  DashboardShowPageHeader                                           : "DashboardShowPageHeader",
  DashboardShowSubTitle                                             : "DashboardShowSubTitle",
  DashboardShowTitle                                                : "DashboardShowTitle",
  DashboardShowWidgetsAlerts                                        : "DashboardShowWidgetsAlerts",
  DashboardShowWidgetsLicences                                      : "DashboardShowWidgetsLicences",
  DashboardShowWidgetsSimUsageCosts                                 : "DashboardShowWidgetsSimUsageCosts",
  DashboardShowWidgetStepSelector                                   : "DashboardShowWidgetStepSelector",
  DashboardShowWidgetsTotalCosts                                    : "DashboardShowWidgetsTotalCosts",
  DashboardShowWidgetTotalCompanies                                 : "DashboardShowWidgetTotalCompanies",
  DashboardStatementDownloadEnabled                                 : "DashboardStatementDownloadEnabled",
  DashboardTopUsersMostCostCentreCost                               : "DashboardTopUsersMostCostCentreCost",
  DashboardTopUsersMostCostCentreUsageMb                            : "DashboardTopUsersMostCostCentreUsageMb",
  DashboardTopUsersShowTag                                          : "DashboardTopUsersShowTag",
  DashboardTopUsersShowTag2                                         : "DashboardTopUsersShowTag2",
  DashboardUsageDisplayTbEnabled                                    : "DashboardUsageDisplayTbEnabled",
  DeviceManagementIntune                                            : "DeviceManagementIntune",
  DeviceManagementIntuneOnlyIosAndAndroid                           : "DeviceManagementIntuneOnlyIosAndAndroid",
  DeviceManagementLatestVersion_Android                             : "DeviceManagementLatestVersion_Android",
  DeviceManagementLatestVersion_iOS_Major                           : "DeviceManagementLatestVersion_iOS_Major",
  DeviceManagementLatestVersion_iOS_Minor                           : "DeviceManagementLatestVersion_iOS_Minor",
  DeviceManagementRequireLicence                                    : "DeviceManagementRequireLicence",
  DownloadCentreCollapseContainers                                  : "DownloadCentreCollapseContainers",
  DownloadCentreCollapseSureSimLogo                                 : "DownloadCentreCollapseSureSimLogo",
  DropdownCompanySuperHierarchyEnabled                              : "DropdownCompanySuperHierarchyEnabled",
  DropdownCompanyUtelizeResellerReplacement                         : "DropdownCompanyUtelizeResellerReplacement",
  DropdownsProvideSelectAllOption                                   : "DropdownsProvideSelectAllOption",
  DropdownsTrackingCompanyId                                        : "DropdownsTrackingCompanyId",
  EnableSupportOnNew                                                : "EnableSupportOnNew",
  FieldAliasTag                                                     : "FieldAliasTag",
  FieldAliasTag2                                                    : "FieldAliasTag2",
  FieldAliasUsername                                                : "FieldAliasUsername",
  FormAddress_AddressSearch                                         : "FormAddress_AddressSearch",
  FormAddressAutofill                                               : "FormAddressAutofill",
  FormChatGptShowConnectionTypeIcon                                 : "FormChatGptShowConnectionTypeIcon",
  FormCommunicationShowChannelEmail                                 : "FormCommunicationShowChannelEmail",
  FormCommunicationShowChannelEmailTrm                              : "FormCommunicationShowChannelEmailTrm",
  FormCommunicationShowChannelInApp                                 : "FormCommunicationShowChannelInApp",
  FormCommunicationShowChannelInAppTrm                              : "FormCommunicationShowChannelInAppTrm",
  FormCommunicationShowChannelSms                                   : "FormCommunicationShowChannelSms",
  FormCommunicationShowChannelSmsTrm                                : "FormCommunicationShowChannelSmsTrm",
  FormCommunicationShowReplyIcon                                    : "FormCommunicationShowReplyIcon",
  FormCommunicationShowTemplateSelector                             : "FormCommunicationShowTemplateSelector",
  FormCommunicationSmsAllowanceFromSenderCompany                    : "FormCommunicationSmsAllowanceFromSenderCompany",
  FormCompanyAccountRefMandatory                                    : "FormCompanyAccountRefMandatory",
  FormCompanyAddressMandatory                                       : "FormCompanyAddressMandatory",
  FormCompanyAutofill                                               : "FormCompanyAutofill",
  FormCompanyEnableAlertsOnNew                                      : "FormCompanyEnableAlertsOnNew",
  FormCompanyEnableLicenceDetailsOnNew                              : "FormCompanyEnableLicenceDetailsOnNew",
  FormCompanyRegNoMandatory                                         : "FormCompanyRegNoMandatory",
  FormCompanyRequireSsoTenantIdMicrosoft                            : "FormCompanyRequireSsoTenantIdMicrosoft",
  FormCompanyResellerOnlyParents                                    : "FormCompanyResellerOnlyParents",
  FormCompanySetInvoiceOnAdd                                        : "FormCompanySetInvoiceOnAdd",
  FormCompanySetMdmDesensitiseOnAdd                                 : "FormCompanySetMdmDesensitiseOnAdd",
  FormCompanySetPortalAccessOnAdd                                   : "FormCompanySetPortalAccessOnAdd",
  FormCompanySetStatementOnAdd                                      : "FormCompanySetStatementOnAdd",
  FormCompanyShowAlerts                                             : "FormCompanyShowAlerts",
  FormCompanyShowBillingOnly                                        : "FormCompanyShowBillingOnly",
  FormCompanyShowDeviceManagement                                   : "FormCompanyShowDeviceManagement",
  FormCompanyShowInvoiceDetails                                     : "FormCompanyShowInvoiceDetails",
  FormCompanyShowLicenceDetails                                     : "FormCompanyShowLicenceDetails",
  FormCompanyShowMessageIcon                                        : "FormCompanyShowMessageIcon",
  FormCompanyShowPortalDetails                                      : "FormCompanyShowPortalDetails",
  FormCompanyShowSingleSignOn                                       : "FormCompanyShowSingleSignOn",
  FormCompanyShowSpendLimits                                        : "FormCompanyShowSpendLimits",
  FormCompanyShowTariffAndPricing                                   : "FormCompanyShowTariffAndPricing",
  FormCompanySubmitEnableOnEdit                                     : "FormCompanySubmitEnableOnEdit",
  FormCompanyTabTitleAlerts                                         : "FormCompanyTabTitleAlerts",
  FormCompanyTabTitleBasicDetails                                   : "FormCompanyTabTitleBasicDetails",
  FormCompanyTabTitleDeviceManagement                               : "FormCompanyTabTitleDeviceManagement",
  FormCompanyTabTitleInvoice                                        : "FormCompanyTabTitleInvoice",
  FormCompanyTabTitleLicencing                                      : "FormCompanyTabTitleLicencing",
  FormCompanyTabTitlePortal                                         : "FormCompanyTabTitlePortal",
  FormCompanyTabTitleSingleSignOn                                   : "FormCompanyTabTitleSingleSignOn",
  FormCompanyTabTitleSpendLimits                                    : "FormCompanyTabTitleSpendLimits",
  FormCompanyTabTitleSupport                                        : "FormCompanyTabTitleSupport",
  FormCompanyTabTitleTariffs                                        : "FormCompanyTabTitleTariffs",
  FormCompanyUsageLimitsShowDataLimit                               : "FormCompanyUsageLimitsShowDataLimit",
  FormCompanyUsageLimitsShowNoLimit                                 : "FormCompanyUsageLimitsShowNoLimit",
  FormCompanyVATNumberMandatory                                     : "FormCompanyVATNumberMandatory",
  FormLastPassKillerEnabled                                         : "LastPassKillerEnabled",
  FormLoginAllowUsePasswordWhenSso                                  : "FormLoginAllowUsePasswordWhenSso",
  FormLoginAutoComplete                                             : "FormLoginAutoComplete",
  FormManageApplicationUsageShow                                    : "FormManageApplicationUsageShow",
  FormManageEsimDefaultProductsOnly                                 : "FormManageEsimDefaultProductsOnly",
  FormManageEsimExclusionProfilesShow                               : "FormManageEsimExclusionProfilesShow",
  FormManageEsimGetDataBeforeOpenModal                              : "FormManageEsimGetDataBeforeOpenModal",
  FormManageEsimMoreMessaging                                       : "FormManageEsimMoreMessaging",
  FormManageEsimShowAlerts                                          : "FormManageEsimShowAlerts",
  FormManageEsimTimelineShow                                        : "FormManageEsimTimelineShow",
  FormTimelineApplicationSummaryMaxHeight                           : "FormTimelineApplicationSummaryMaxHeight",
  FormTimelineApplicationSummaryShowChart                           : "FormTimelineApplicationSummaryShowChart",
  FormTimelineApplicationSummaryShowContainer                       : "FormTimelineApplicationSummaryShowContainer",
  FormTimelineApplicationSummaryShowLegend                          : "FormTimelineApplicationSummaryShowLegend",
  FormTimelineCountryUsageAndDetailMaxHeight                        : "FormTimelineCountryUsageAndDetailMaxHeight",
  FormTimelineCountryUsageSummaryMaxHeight                          : "FormTimelineCountryUsageSummaryMaxHeight",
  FormTimelineLinksExpansionShow                                    : "FormTimelineLinksExpansionShow",
  FormTimelineSessionThresholdMB                                    : "FormTimelineSessionThresholdMB",
  FormTimelineSimActivityCircles                                    : "FormTimelineSimActivityCircles",
  FormTimelineTodaysUsageGraphInMbOnly                              : "FormTimelineTodaysUsageGraphInMbOnly",
  FormUsageLimitsShowDataLimit                                      : "FormUsageLimitsShowDataLimit",
  FormUsageLimitsHintCurrentSpendLimit                              : "FormUsageLimitsHintCurrentSpendLimit",
  FormUsageLimitsHintSelfAuthSpendLimit                             : "FormUsageLimitsHintSelfAuthSpendLimit",
  FormUsageLimitsHintSpendLimit                                     : "FormUsageLimitsHintSpendLimit",
  FormUsageLimitsShowHintCurrentSpendLimit                          : "FormUsageLimitsShowHintCurrentSpendLimit",
  FormUsageLimitsShowHintSelfAuthSpendLimit                         : "FormUsageLimitsShowHintSelfAuthSpendLimit",
  FormUsageLimitsShowHintSpendLimit                                 : "FormUsageLimitsShowHintSpendLimit",
  FormUsageLimitsShowNoLimit                                        : "FormUsageLimitsShowNoLimit",
  FormUsageLimitsShowSelfAuthSpendLimit                             : "FormUsageLimitsShowSelfAuthSpendLimit",
  FormUsageLimitsTextCurrentSpendLimit                              : "FormUsageLimitsTextCurrentSpendLimit",
  FormUsageLimitsTextSelfAuthSpendLimit                             : "FormUsageLimitsTextSelfAuthSpendLimit",
  FormUsageLimitsTextSpendLimit                                     : "FormUsageLimitsTextSpendLimit",
  FormUserAutofill                                                  : "FormUserAutofill",
  FormUserRefreshApiGetAfterViewAssociate                           : "FormUserRefreshApiGetAfterViewAssociate",
  FormUserRefreshApiGetAfterViewEsim                                : "FormUserRefreshApiGetAfterViewEsim",
  FormUserRefreshApiGetAfterViewPortal                              : "FormUserRefreshApiGetAfterViewPortal",
  FormUserReset2FaButtonShowIfSso                                   : "FormUserReset2FaButtonShowIfSso",
  FormUserResetPasswordButtonShowIfSso                              : "FormUserResetPasswordButtonShowIfSso",
  FormUserSetSendBillOnAdd                                          : "FormUserSetSendBillOnAdd",
  FormUserShowActiveAssociate                                       : "FormUserShowActiveAssociate",
  FormUserShowActiveEsim                                            : "FormUserShowActiveEsim",
  FormUserShowActivePortal                                          : "FormUserShowActivePortal",
  FormUserShowBillRecipientAssociate                                : "FormUserShowBillRecipientAssociate",
  FormUserShowBillRecipientEsim                                     : "FormUserShowBillRecipientEsim",
  FormUserShowBillRecipientPortal                                   : "FormUserShowBillRecipientPortal",
  FormUserShowCostCentres                                           : "FormUserShowCostCentres",
  FormUserShowFullCliInfoIfAllocated                                : "FormUserShowFullCliInfoIfAllocated",
  FormUserShowMessageIconAssociate                                  : "FormUserShowMessageIconAssociate",
  FormUserShowMessageIconEsim                                       : "FormUserShowMessageIconEsim",
  FormUserShowMessageIconPortal                                     : "FormUserShowMessageIconPortal",
  FormUserShowOccupationAssociate                                   : "FormUserShowOccupationAssociate",
  FormUserShowOccupationEsim                                        : "FormUserShowOccupationEsim",
  FormUserShowOccupationPortal                                      : "FormUserShowOccupationPortal",
  FormUserShowUsernameAndMobileWhenDevice                           : "FormUserShowUsernameAndMobileWhenDevice",
  FormUserShowUserRole                                              : "FormUserShowUserRole",
  FormUserSubmitEnableOnEdit                                        : "FormUserSubmitEnableOnEdit",
  FormUserUseInternationalDialCode                                  : "FormUserUseInternationalDialCode",
  GridAuditWidgetsMultiColoured                                     : "GridAuditWidgetsMultiColoured",
  GridButtonsOnHoverGrow                                            : "GridButtonsOnHoverGrow",
  GridCacheEnabled                                                  : "GridCacheEnabled",
  GridColumnChooserItemsSortAlpha                                   : "GridColumnChooserItemsSortAlpha",
  GridCompaniesShowId                                               : "GridCompaniesShowId",
  GridCopyCellValueToClipboard                                      : "GridCopyCellValueToClipboard",
  GridDefaultColumnMinWidth                                         : "GridDefaultColumnMinWidth",
  GridEmbeddedInviewUsersPageSize                                   : "GridEmbeddedInviewUsersPageSize",
  GridFinancialReportsFullnameAsUsername                            : "GridFinancialReportsFullnameAsUsername",
  GridFinancialReportsResellerLevelReporting                        : "GridFinancialReportsResellerLevelReporting",
  GridHistoricOrdersShowFullname                                    : "GridHistoricOrdersShowFullname",
  GridHistoricOrdersShowUsername                                    : "GridHistoricOrdersShowUsername",
  GridLastDataSessionsSelectTop                                     : "GridLastDataSessionsSelectTop",
  GridLicencesCompanyAllocatedShowCompanyName                       : "GridLicencesCompanyAllocatedShowCompanyName",
  GridLicencesCompanyVisibleShowCompanyName                         : "GridLicencesCompanyVisibleShowCompanyName",
  GridManageEsimBulkActionsEnabled                                  : "GridManageEsimBulkActionsEnabled",
  GridManageEsimColumnMinWidth                                      : "GridManageEsimColumnMinWidth",
  GridManageEsimNearLimitThreshold                                  : "GridManageEsimNearLimitThreshold",
  GridManageEsimShowFullname                                        : "GridManageEsimShowFullname",
  GridManageEsimShowLastUsage                                       : "GridManageEsimShowLastUsage",
  GridManageEsimShowLimitUsed                                       : "GridManageEsimShowLimitUsed",
  GridManageEsimShowStats                                           : "GridManageEsimShowStats",
  GridManageEsimShowSummaryCost                                     : "GridManageEsimShowSummaryCost",
  GridManageEsimShowSummaryUsage                                    : "GridManageEsimShowSummaryUsage",
  GridManageEsimShowSummaryUsageLimit                               : "GridManageEsimShowSummaryUsageLimit",
  GridManageEsimShowUsageLimit                                      : "GridManageEsimShowUsageLimit",
  GridManageEsimShowUsername                                        : "GridManageEsimShowUsername",
  GridManageEsimShowWidgets                                         : "GridManageEsimShowWidgets",
  GridManageEsimWidgetsMultiColoured                                : "GridManageEsimWidgetsMultiColoured",
  GridMdmDevicesCompanyShowCompanyField                             : "GridMdmDevicesCompanyShowCompanyField",
  GridMdmDevicesCompanyShowSyncButton                               : "GridMdmDevicesCompanyShowSyncButton",
  GridMdmDevicesEnableEOLSourceURLEOLValidation                     : "GridMdmDevicesEnableEOLSourceURLEOLValidation",
  GridMdmDevicesEnableEOSSourceURLEOSValidation                     : "GridMdmDevicesEnableEOSSourceURLEOSValidation",
  GridMdmDevicesIntuneColumnMinWidth                                : "GridMdmDevicesIntuneColumnMinWidth",
  GridMdmDevicesIntuneLastDaysForUsage                              : "ControllerInviewApi_GetLastActiveCLIData_DaysForNoUsage",
  GridMdmDevicesIntuneShowCompanyField                              : "GridMdmDevicesIntuneShowCompanyField",
  GridMdmDevicesIntuneShowImportButton                              : "GridMdmDevicesIntuneShowImportButton",
  GridMdmDevicesIntuneShowSyncButton                                : "GridMdmDevicesIntuneShowSyncButton",
  GridMdmUsersIntuneShowCompanyField                                : "GridMdmUsersIntuneShowCompanyField",
  GridMdmUsersIntuneShowImportButton                                : "GridMdmUsersIntuneShowImportButton",
  GridMdmUsersIntuneShowSyncButton                                  : "GridMdmUsersIntuneShowSyncButton",
  GridModalDropdownsSearchable                                      : "GridModalDropdownsSearchable",
  GridNetworkEventsCellInfoShow                                     : "GridNetworkEventsCellInfoShow",
  GridRememberColumns                                               : "GridRememberColumns",
  GridRowClickTimerMilliSecs                                        : "GridRowClickTimerMilliSecs",
  GridSearchPanelWidthPx                                            : "GridSearchPanelWidthPx",
  GridShowAll                                                       : "GridShowAll",
  GridShowButtons                                                   : "GridShowButtons",
  GridShowDragIcons                                                 : "GridShowDragIcons",
  GridShowId                                                        : "GridShowId",
  GridShowIdSystemAdmin                                             : "GridShowIdSystemAdmin",
  GridSureSimBlue                                                   : "GridSureSimBlue",
  GridUsersAssociateAutoSelectCompanyOnUserAdd                      : "GridUsersAssociateAutoSelectCompanyOnUserAdd",
  GridUsersAssociateShowFullname                                    : "GridUsersAssociateShowFullname",
  GridUsersAssociateShowId                                          : "GridUsersAssociateShowId",
  GridUsersAssociateShowInviewUserId                                : "GridUsersAssociateShowInviewUserId",
  GridUsersAssociateShowUsername                                    : "GridUsersAssociateShowUsername",
  GridUsersEsimAutoSelectCompanyOnUserAdd                           : "GridUsersEsimAutoSelectCompanyOnUserAdd",
  GridUsersEsimCollapseContainers                                   : "GridUsersEsimCollapseContainers",
  GridUsersEsimContainerCloseAllow                                  : "GridUsersEsimContainerCloseAllow",
  GridUsersEsimShowFullname                                         : "GridUsersEsimShowFullname",
  GridUsersEsimShowId                                               : "GridUsersEsimShowId",
  GridUsersEsimShowInviewCostCentreID                               : "GridUsersEsimShowInviewCostCentreID",
  GridUsersEsimShowInviewUserId                                     : "GridUsersEsimShowInviewUserId",
  GridUsersEsimShowUsername                                         : "GridUsersEsimShowUsername",
  GridUsersEsimTitleShowHintText                                    : "GridUsersEsimTitleShowHintText",
  GridUsersEsimTransferUserData                                     : "GridUsersEsimTransferUserData",
  GridUserSessionsWidgetsMultiColoured                              : "GridUserSessionsWidgetsMultiColoured",
  GridUsersPortalAutoSelectCompanyOnUserAdd                         : "GridUsersPortalAutoSelectCompanyOnUserAdd",
  GridUsersPortalShowFullname                                       : "GridUsersPortalShowFullname",
  GridUsersPortalShowId                                             : "GridUsersPortalShowId",
  GridUsersPortalShowUsername                                       : "GridUsersPortalShowUsername",
  GridViewModernStyle                                               : "GridViewModernStyle",
  Infrastructure_Inview_ConnectionString                            : "Infrastructure_Inview_ConnectionString",
  Infrastructure_InviewApi                                          : "Infrastructure_InviewApi",
  Infrastructure_SS_ConnectionString                                : "Infrastructure_SS_ConnectionString",
  InventoryEnabled                                                  : "InventoryEnabled",
  InviewAutoCreateCostCentres                                       : "InviewAutoCreateCostCentres",
  InviewPadlock                                                     : "InviewPadlock",
  InviewUserListLimit                                               : "InviewUserListLimit",
  KillCompaniesAndUsers                                             : "KillCompaniesAndUsers",
  KillCompaniesAndUsersSureSimOnly                                  : "KillCompaniesAndUsersSureSimOnly",
  LastDatabaseUpdate                                                : "LastDatabaseUpdate",
  LicencesAllowOverrideStartDate                                    : "LicencesAllowOverrideStartDate",
  LicencesBilledEditOverrideEnabled                                 : "LicencesBilledEditOverrideEnabled",
  LicencesBillStartOfNextMonthBundle                                : "LicencesBillStartOfNextMonthBundle",
  LicencesBillStartOfNextMonthFeature                               : "LicencesBillStartOfNextMonthFeature",
  LicencesBillStartOfNextMonthPlatform                              : "LicencesBillStartOfNextMonthPlatform",
  LicencesBillStartOfNextMonthPoolBundle                            : "LicencesBillStartOfNextMonthPoolBundle",
  LicencesBillStartOfNextMonthUsage                                 : "LicencesBillStartOfNextMonthUsage",
  LicencesEnableBundle                                              : "LicencesEnableBundle",
  LicencesEnableFeature                                             : "LicencesEnableFeature",
  LicencesEnablePoolBundle                                          : "LicencesEnablePoolBundle",
  LicencesEnableUsage                                               : "LicencesEnableUsage",
  LicencesEndedHide                                                 : "LicencesEndedHide",
  LicencesLockEditAfterBilledBundle                                 : "LicencesLockEditAfterBilledBundle",
  LicencesLockEditAfterBilledPoolBundle                             : "LicencesLockEditAfterBilledPoolBundle",
  LicencesLockEditAfterBilledUsage                                  : "LicencesLockEditAfterBilledUsage",
  LicencesPlatformMultipleQuantity                                  : "LicencesPlatformMultipleQuantity",
  LicencesPlatformMustHaveForProvision                              : "LicencesPlatformMustHaveForProvision",
  LicencesPlatformOnlyDeleteUnused                                  : "LicencesPlatformOnlyDeleteUnused",
  LicencesPoolBundleEnablePeriodAndFrequency                        : "LicencesPoolBundleEnablePeriodAndFrequency",
  LicencesPoolBundleMultipleQuantity                                : "LicencesPoolBundleMultipleQuantity",
  LicencesShowSystemOwnedToUsers                                    : "LicencesShowSystemOwnedToUsers",
  LicencesUsageZoneOverlapCheck                                     : "LicencesUsageZoneOverlapCheck",
  LocationServicesEnabled                                           : "LocationServicesEnabled",
  LocationServicesLastLocationOnlyCompanyEnabled                    : "LocationServicesLastLocationOnlyCompanyEnabled",
  LocationServicesLastLocationOnlySimEnabled                        : "LocationServicesLastLocationOnlySimEnabled",
  LocationServicesMapSettingsEnabled                                : "LocationServicesMapSettingsEnabled",
  LocationServicesTileAttribution                                   : "LocationServicesTileAttribution",
  LocationServicesTileURL                                           : "LocationServicesTileURL",
  LoginClearBrowserStorageEnabled                                   : "LoginClearBrowserStorageEnabled",
  LoginCookieWarningShow                                            : "LoginCookieWarningShow",
  ManageEsimVersion2                                                : "ManageEsimVersion2",
  MdmComplianceCampaignLogsShowCompanyField                         : "MdmComplianceCampaignLogsShowCompanyField",
  MdmComplianceCampaignLogsShowTabs                                 : "MdmComplianceCampaignLogsShowTabs",
  MdmComplianceCampaignsEnabled                                     : "MdmComplianceCampaignsEnabled",
  MdmDashboardCollapseContainers                                    : "MdmDashboardCollapseContainers",
  MdmDashboardContainerCloseAllow                                   : "MdmDashboardContainerCloseAllow",
  MdmDashboardDevicesLess_X_GbRemaining                             : "MdmDashboardDevicesLess_X_GbRemaining",
  MdmDashboardOnRestoreExpandDrilldowns                             : "MdmDashboardOnRestoreExpandDrilldowns",
  MdmDashboardShowImportButton                                      : "MdmDashboardShowImportButton",
  MdmDashboardShowLastSyncDateTime                                  : "MdmDashboardShowLastSyncDateTime",
  MdmDashboardShowLastSyncedBy                                      : "MdmDashboardShowLastSyncedBy",
  MdmDashboardShowPdfExportButton                                   : "MdmDashboardShowPdfExportButton",
  MdmDashboardShowSyncButton                                        : "MdmDashboardShowSyncButton",
  MdmDashboardShowTabs                                              : "MdmDashboardShowTabs",
  MdmDashboardSyncPreviousCompareAllow                              : "MdmDashboardSyncPreviousCompareAllow",
  MdmDashboardTitle                                                 : "MdmDashboardTitle",
  MdmDashboardTitleShowHintText                                     : "MdmDashboardTitleShowHintText",
  MdmDeviceComplianceCollapseContainers                             : "MdmDeviceComplianceCollapseContainers",
  MdmDeviceComplianceContainerCloseAllow                            : "MdmDeviceComplianceContainerCloseAllow",
  MdmDeviceComplianceShowStatTenant                                 : "MdmDeviceComplianceShowStatTenant",
  MdmDeviceComplianceShowTabs                                       : "MdmDeviceComplianceShowTabs",
  MdmDeviceComplianceTitleShowHintText                              : "MdmDeviceComplianceTitleShowHintText",
  MdmDeviceEndOfLifePrecision                                       : "MdmDeviceEndOfLifePrecision",
  MdmDeviceEndOfSupportPrecision                                    : "MdmDeviceEndOfSupportPrecision",
  MdmDeviceEndOfSupportWidgetsEnabled                               : "MdmDeviceEndOfSupportWidgetsEnabled",
  MdmDeviceNotificationLogsShowCompanyField                         : "MdmDeviceNotificationLogsShowCompanyField",
  MdmDeviceNotificationLogsShowTabs                                 : "MdmDeviceNotificationLogsShowTabs",
  MdmDevicesCompanyConfigShowCompanyField                           : "MdmDevicesCompanyConfigShowCompanyField",
  MdmDevicesCompanyConfigShowTabs                                   : "MdmDevicesCompanyConfigShowTabs",
  MdmDevicesCompanyShowTabs                                         : "MdmDevicesCompanyShowTabs",
  MdmDevicesIntuneShowTabs                                          : "MdmDevicesIntuneShowTabs",
  MdmDevicesIntuneUseSingleTemplate                                 : "MdmDevicesIntuneUseSingleTemplate",
  MdmDevicesShowTabs                                                : "MdmDevicesShowTabs",
  MdmDevicesTemplatesComplianceCampaignsShowCompanyField            : "MdmDevicesTemplatesComplianceCampaignsShowCompanyField",
  MdmDevicesTemplatesRemediationShowCompanyField                    : "MdmDevicesTemplatesRemediationShowCompanyField",
  MdmDevicesTemplatesRemediationToStatusShowCompanyField            : "MdmDevicesTemplatesRemediationToStatusShowCompanyField",
  MdmRemediationCcManualRunsEnabled                                 : "MdmRemediationCcManualRunsEnabled",
  MdmRemediationCcManualRunsShow                                    : "MdmRemediationCcManualRunsShow",
  MdmRemediationCcTemplateDropDownsEnabled                          : "MdmRemediationCcTemplateDropDownsEnabled",
  MdmRemediationEnabled                                             : "MdmRemediationEnabled",
  MdmRemediationOneOffMessagesEnabled                               : "MdmRemediationOneOffMessagesEnabled",
  MenuShowAssociates                                                : "MenuShowAssociates",
  MenuShowAvailableSims                                             : "MenuShowAvailableSims",
  MenuShowCommConfig                                                : "MenuShowCommConfig",
  MenuShowDemonstrations                                            : "MenuShowDemonstrations",
  MenuShowHelp                                                      : "MenuShowHelp",
  MenuShowLinks                                                     : "MenuShowLinks",
  MenuShowLinksNPerf                                                : "MenuShowLinksNPerf",
  MenuShowLinksNPerfMap5G                                           : "MenuShowLinksNPerfMap5G",
  MenuShowLinksNPerfMapCoverage                                     : "MenuShowLinksNPerfMapCoverage",
  MenuShowLinksNPerfMapSpeed                                        : "MenuShowLinksNPerfMapSpeed",
  MenuShowLocationServices                                          : "MenuShowLocationServices",
  MenuShowMdmDeviceCampaigns                                        : "MenuShowMdmDeviceCampaigns",
  MenuShowMdmDeviceCompliance                                       : "MenuShowMdmDeviceCompliance",
  MenuShowMdmDeviceRemediation                                      : "MenuShowMdmDeviceRemediation",
  MenuShowMdmDevicesAll                                             : "MenuShowMdmDevicesAll",
  MenuShowMdmDevicesCompany                                         : "MenuShowMdmDevicesCompany",
  MenuShowMdmDevicesCompanyConfig                                   : "MenuShowMdmDevicesCompanyConfig",
  MenuShowMdmDevicesTemplatesCampaigns                              : "MenuShowMdmDevicesTemplatesCampaigns",
  MenuShowMdmDevicesTemplatesRemediation                            : "MenuShowMdmDevicesTemplatesRemediation",
  MenuShowMdmDevicesTemplatesRemediationToStatus                    : "MenuShowMdmDevicesTemplatesRemediationToStatus",
  MenuShowMdmIntuneSimExceptions                                    : "MenuShowMdmIntuneSimExceptions",
  MenuShowMessaging                                                 : "MenuShowMessaging",
  MenuShowNewDashboard                                              : "MenuShowNewDashboard",
  MenuShowProvisioningHistory                                       : "MenuShowProvisioningHistory",
  MenuShowRiskManagement                                            : "MenuShowRiskManagement",
  MenuShowRiskManagementTravelRisk                                  : "MenuShowRiskManagementTravelRisk",
  MenuShowSignals                                                   : "MenuShowSignals",
  MenuShowSignalsBreachExposure                                     : "MenuShowSignalsBreachExposure",
  MenuShowSignalsCorporateHealth                                    : "MenuShowSignalsCorporateHealth",
  MenuShowSignalsDashboard                                          : "MenuShowSignalsDashboard",
  MenuShowSignalsDeviceVulnerabilities                              : "MenuShowSignalsDeviceVulnerabilities",
  MenuShowSignalsTravelRisk                                         : "MenuShowSignalsTravelRisk",
  MenuShowSignalsTravelRiskAdvisories                               : "MenuShowSignalsTravelRiskAdvisories",
  MenuShowSignalsTravelRiskAlerts                                   : "MenuShowSignalsTravelRiskAlerts",
  MenuShowSignalsTravelRiskCityReports                              : "MenuShowSignalsTravelRiskCityReports",
  MenuShowSignalsTravelRiskComparison                               : "MenuShowSignalsTravelRiskComparison",
  MenuShowSignalsTravelRiskCountryReports                           : "MenuShowSignalsTravelRiskCountryReports",
  MenuShowSignalsTravelRiskCountryRiskLevels                        : "MenuShowSignalsTravelRiskCountryRiskLevels",
  MenuShowSignalsTravelRiskExposure                                 : "MenuShowSignalsTravelRiskExposure",
  MenuShowSignalsTravelRiskTripBrief                                : "MenuShowSignalsTravelRiskTripBrief",
  MenuShowTickets                                                   : "MenuShowTickets",
  MenuShowTimeline                                                  : "MenuShowTimeline",
  MenuTextLinksIntuneDash                                           : "MenuTextLinksIntuneDash",
  MenuTextLinksNPerf                                                : "MenuTextLinksNPerf",
  MenuTextLinksNPerfMap5G                                           : "MenuTextLinksNPerfMap5G",
  MenuTextLinksNPerfMapCoverage                                     : "MenuTextLinksNPerfMapCoverage",
  MenuTextLinksNPerfMapSpeed                                        : "MenuTextLinksNPerfMapSpeed",
  ModalBackGround                                                   : "ModalBackGround",
  ModalGridHeightEmbedded                                           : "ModalGridHeightEmbedded",
  NominatimLocationCapture                                          : "NominatimLocationCapture",
  PageCompHeaderShowDateSelectorViaIconClick                        : "PageCompHeaderShowDateSelectorViaIconClick",
  PageLinksEmbedNPerf                                               : "PageLinksEmbedNPerf",
  PagesDemonstrationsShowHowdyGo                                    : "PagesDemonstrationsShowHowdyGo",
  PagesTitlesEmbedButtons                                           : "PagesTitlesEmbedButtons",
  PagesTitlesEmbedCompanyDropDown                                   : "PagesTitlesEmbedCompanyDropDown",
  PagesTitlesEmbedDateDropDown                                      : "PagesTitlesEmbedDateDropDown",
  PagesTitlesEmbedReportDropDown                                    : "PagesTitlesEmbedReportDropDown",
  PagesTitlesUseSureSimBlue                                         : "PagesTitlesUseSureSimBlue",
  PhoneNumberServiceDigitsOnly                                      : "PhoneNumberServiceDigitsOnly",
  PollObservableAlertsTimesTriggeredCountryMilliSecs                : "PollObservableAlertsTimesTriggeredCountryMilliSecs",
  PollObservableAlertsTimesTriggeredUsageMilliSecs                  : "PollObservableAlertsTimesTriggeredUsageMilliSecs",
  PollObservableAlertsTotalLimitIncreasesMilliSecs                  : "PollObservableAlertsTotalLimitIncreasesMilliSecs",
  PollObservableAlertsTotalThrottlesMilliSecs                       : "PollObservableAlertsTotalThrottlesMilliSecs",
  PollObservableApplicationSummaryMilliSecs                         : "PollObservableApplicationSummaryMilliSecs",
  PollObservableCompanyTotalCostMilliSecs                           : "PollObservableCompanyTotalCostMilliSecs",
  PollObservableCompanyTotalUsageMilliSecs                          : "PollObservableCompanyTotalUsageMilliSecs",
  PollObservableCompliance_JailbrokenMilliSecs                      : "PollObservableCompliance_JailbrokenMilliSecs",
  PollObservableCompliance_PinCodeMilliSecs                         : "PollObservableCompliance_PinCodeMilliSecs",
  PollObservableCompliance_SoftwareMilliSecs                        : "PollObservableCompliance_SoftwareMilliSecs",
  PollObservableCountryDetailsMilliSecs                             : "PollObservableCountryDetailsMilliSecs",
  PollObservableCountryUsageSummaryMilliSecs                        : "PollObservableCountryUsageSummaryMilliSecs",
  PollObservableDevicesAverageAgeMilliSecs                          : "PollObservableDevicesAverageAgeMilliSecs",
  PollObservableDevicesByCarrierMilliSecs                           : "PollObservableDevicesByCarrierMilliSecs",
  PollObservableDevicesByCompanyManagedMilliSecs                    : "PollObservableDevicesByCompanyManagedMilliSecs",
  PollObservableDevicesByEncryptedMilliSecs                         : "PollObservableDevicesByEncryptedMilliSecs",
  PollObservableDevicesByJailbrokenMilliSecs                        : "PollObservableDevicesByJailbrokenMilliSecs",
  PollObservableDevicesByManagementStateMilliSecs                   : "PollObservableDevicesByManagementStateMilliSecs",
  PollObservableDevicesByManufacturerMilliSecs                      : "PollObservableDevicesByManufacturerMilliSecs",
  PollObservableDevicesByOperatingSystemCompliant_IntuneMilliSecs   : "PollObservableDevicesByOperatingSystemCompliant_IntuneMilliSecs",
  PollObservableDevicesByOperatingSystemCompliant_OursMilliSecs     : "PollObservableDevicesByOperatingSystemCompliant_OursMilliSecs",
  PollObservableDevicesByOperatingSystemCompliant_OursMinorMilliSecs: "PollObservableDevicesByOperatingSystemCompliant_OursMinorMilliSecs",
  PollObservableDevicesByOperatingSystemMilliSecs                   : "PollObservableDevicesByOperatingSystemMilliSecs",
  PollObservableDevicesBySupervisedMilliSecs                        : "PollObservableDevicesBySupervisedMilliSecs",
  PollObservableDevicesCheckedInLast30DaysMilliSecs                 : "PollObservableDevicesCheckedInLast30DaysMilliSecs",
  PollObservableDevicesEndOfLifePerYearMilliSecs                    : "PollObservableDevicesEndOfLifePerYearMilliSecs",
  PollObservableDevicesLess_X_GbRemainingMilliSecs                  : "PollObservableDevicesLess_X_GbRemainingMilliSecs",
  PollObservableDevicesNotCheckedInLast30DaysMilliSecs              : "PollObservableDevicesNotCheckedInLast30DaysMilliSecs",
  PollObservableDevicesNotSupportedEOSMilliSecs                     : "PollObservableDevicesNotSupportedEOSMilliSecs",
  PollObservableDevicesNotSupportedMilliSecs                        : "PollObservableDevicesNotSupportedMilliSecs",
  PollObservableDevicesOldestMilliSecs                              : "PollObservableDevicesOldestMilliSecs",
  PollObservableDevicesSupportedEOSMilliSecs                        : "PollObservableDevicesSupportedEOSMilliSecs",
  PollObservableDevicesSupportedMilliSecs                           : "PollObservableDevicesSupportedMilliSecs",
  PollObservableDevicesTotalNewMilliSecs                            : "PollObservableDevicesTotalNewMilliSecs",
  PollObservableDevicesVolumeAndHealthTrendMilliSecs                : "PollObservableDevicesVolumeAndHealthTrendMilliSecs",
  PollObservableDevicesWithMoreThanOneUserMilliSecs                 : "PollObservableDevicesWithMoreThanOneUserMilliSecs",
  PollObservableDevicesXYearsOrOverMilliSecs                        : "PollObservableDevicesXYearsOrOverMilliSecs",
  PollObservableIccidTodayUsageMilliSecs                            : "PollObservableIccidTodayUsageMilliSecs",
  PollObservableIccidTotalCostMilliSecs                             : "PollObservableIccidTotalCostMilliSecs",
  PollObservableIccidTotalUsageMilliSecs                            : "PollObservableIccidTotalUsageMilliSecs",
  PollObservableNotificationsMilliSecs                              : "PollObservableNotificationsMilliSecs",
  PollObservableOrderWithSpendMilliSecs                             : "PollObservableOrderWithSpendMilliSecs",
  PollObservableSimActivityMilliSecs                                : "PollObservableSimActivityMilliSecs",
  PollObservableSimNotInactiveMilliSecs                             : "PollObservableSimNotInactiveMilliSecs",
  PollObservableStatementBatchMilliSecs                             : "PollObservableStatementBatchMilliSecs",
  PollObservableTimelineMilliSecs                                   : "PollObservableTimelineMilliSecs",
  PollObservableTotalCompaniesCountMilliSecs                        : "PollObservableTotalCompaniesCountMilliSecs",
  PollObservableTotalCostsLicenceMilliSecs                          : "PollObservableTotalCostsLicenceMilliSecs",
  PollObservableTotalCostsUsageAndLicenceMilliSecs                  : "PollObservableTotalCostsUsageAndLicenceMilliSecs",
  PollObservableTotalCostsUsageMilliSecs                            : "PollObservableTotalCostsUsageMilliSecs",
  PollObservableTotalDeviceCountMilliSecs                           : "PollObservableTotalDeviceCountMilliSecs",
  PollObservableTotalPlatformLicencesCountMilliSecs                 : "PollObservableTotalPlatformLicencesCountMilliSecs",
  PollObservableTotalPlatformLicencesLiveButEndedMilliSecs          : "PollObservableTotalPlatformLicencesLiveButEndedMilliSecs",
  PollObservableTotalPlatformLicencesUnusedMilliSecs                : "PollObservableTotalPlatformLicencesUnusedMilliSecs",
  PollObservableTotalProfitUsageMilliSecs                           : "PollObservableTotalProfitUsageMilliSecs",
  PollObservableTotalPurchaseCostsUsageMilliSecs                    : "PollObservableTotalPurchaseCostsUsageMilliSecs",
  PollObservableTotalSimCountMilliSecs                              : "PollObservableTotalSimCountMilliSecs",
  PollObservableTotalSimProfitMilliSecs                             : "PollObservableTotalSimProfitMilliSecs",
  PollObservableTotalUsageMilliSecs                                 : "PollObservableTotalUsageMilliSecs",
  PollObservableUsersWithMoreThanOneDeviceMilliSecs                 : "PollObservableUsersWithMoreThanOneDeviceMilliSecs",
  PollObservableWebbingLiveDataMilliSecs                            : "PollObservableWebbingLiveDataMilliSecs",
  ProvisioningBulkShowCostCentres                                   : "ProvisioningBulkShowCostCentres",
  ProvisioningShowBulkButton                                        : "ProvisioningShowBulkButton",
  ProvisioningShowManualButton                                      : "ProvisioningShowManualButton",
  ProvisioningShowReservationButtons                                : "ProvisioningShowReservationButtons",
  RisklineShowPageAdvisories                                        : "RisklineShowPageAdvisories",
  RisklineShowPageCountryReport                                     : "RisklineShowPageCountryReport",
  RisklineShowPoweredBy                                             : "RisklineShowPoweredBy",
  RisklineShowSafetyDisclaimer                                      : "RisklineShowSafetyDisclaimer",
  SecurityServerSideEncryption                                      : "SecurityServerSideEncryption",
  SecurityServerSideEncryptionDashboard                             : "SecurityServerSideEncryptionDashboard",
  SecurityServerSideEncryptionWidgets                               : "SecurityServerSideEncryptionWidgets",
  SecurityTotpRecoveryCodesEnabled                                  : "SecurityTotpRecoveryCodesEnabled",
  SecurityTotpRememberDevice                                        : "SecurityTotpRememberDevice",
  ShowBreadcrumbs                                                   : "ShowBreadcrumbs",
  ShowCompanyTabIcons                                               : "ShowCompanyTabIcons",
  ShowFullnameAsUsername                                            : "ShowFullnameAsUsername",
  ShowImeiLocking                                                   : "ShowImeiLocking",
  ShowNetworkReset                                                  : "ShowNetworkReset",
  ShowOrderLogTabIcons                                              : "ShowOrderLogTabIcons",
  ShowOrderTabIcons                                                 : "ShowOrderTabIcons",
  ShowPageHeaders                                                   : "ShowPageHeaders",
  ShowPushViaSMSEmail                                               : "ShowPushViaSMSEmail",
  ShowRedeploy                                                      : "ShowRedeploy",
  ShowSupport                                                       : "ShowSupport",
  ShowTemplateMenuItems                                             : "ShowTemplateMenuItems",
  ShowThemeCog                                                      : "ShowThemeCog",
  ShowTimelineAsModal                                               : "ShowTimelineAsModal",
  ShowTooltips                                                      : "ShowTooltips",
  ShowUserGroups                                                    : "ShowUserGroups",
  ShowUserWizard                                                    : "ShowUserWizard",
  SimProvisioningICCIDReadOnly                                      : "SimProvisioningICCIDReadOnly",
  SimReservationsMaxReservations                                    : "SimReservationsMaxReservations",
  SingleSignOnMicrosoft                                             : "SingleSignOnMicrosoft",
  StatementsUseEnhancedLayout                                       : "StatementsUseEnhancedLayout",
  SupportGetBrowserInfo                                             : "SupportGetBrowserInfo",
  SupportGetBrowserInfoAnonymously                                  : "SupportGetBrowserInfoAnonymously",
  SupportGetClientInfo                                              : "SupportGetClientInfo",
  SupportPlansEnabled                                               : "SupportPlansEnabled",
  SureSimAuditFrontendErrors                                        : "SureSimAuditFrontendErrors",
  SureSimContainerGrow                                              : "SureSimContainerGrow",
  SureSimLogoGrow                                                   : "SureSimLogoGrow",
  SystemAdminFullAccess                                             : "SystemAdminFullAccess",
  SystemLocksEnabled                                                : "SystemLocksEnabled",
  SystemLocksFreeLocksOnPageChange                                  : "SystemLocksFreeLocksOnPageChange",
  SystemLocksShowDetails                                            : "SystemLocksShowDetails",
  SystemLocksShowWarningModal                                       : "SystemLocksShowWarningModal",
  SystemLogoutOnPageRefresh                                         : "SystemLogoutOnPageRefresh",
  SystemOwnedProtectionEnabled                                      : "SystemOwnedProtectionEnabled",
  SystemTestMode                                                    : "SystemTestMode",
  TimelineDisplayVersion2                                           : "TimelineDisplayVersion2",
  TopBarQuickLinksTicketIconSupportMan                              : "TopBarQuickLinksTicketIconSupportMan",
  TopBarQuickLinksTicketLockCompanyWhenTracking                     : "TopBarQuickLinksTicketLockCompanyWhenTracking",
  TopBarShowAddCompanySimUser                                       : "TopBarShowAddCompanySimUser",
  TopBarShowAnimations                                              : "TopBarShowAnimations",
  TopBarShowApps                                                    : "TopBarShowApps",
  TopBarShowCart                                                    : "TopBarShowCart",
  TopBarShowChatGpt                                                 : "TopBarShowChatGpt",
  TopBarShowClock                                                   : "TopBarShowClock",
  TopBarShowClockSeconds                                            : "TopBarShowClockSeconds",
  TopBarShowClockSecondsLocal                                       : "TopBarShowClockSecondsLocal",
  TopBarShowCompanyForUser                                          : "TopBarShowCompanyForUser",
  TopBarShowDarkMode                                                : "TopBarShowDarkMode",
  TopBarShowDownloads                                               : "TopBarShowDownloads",
  TopBarShowFullScreen                                              : "TopBarShowFullScreen",
  TopBarShowHamburger                                               : "TopBarShowHamburger",
  TopBarShowLanguage                                                : "TopBarShowLanguage",
  TopBarShowMenuItems                                               : "TopBarShowMenuItems",
  TopBarShowMobileMigration                                         : "TopBarShowMobileMigration",
  TopBarShowNotifications                                           : "TopBarShowNotifications",
  TopBarShowSearch                                                  : "TopBarShowSearch",
  TopBarShowSsoLoginIcon                                            : "TopBarShowSsoLoginIcon",
  TopBarShowSureSimSearch                                           : "TopBarShowSureSimSearch",
  TopBarShowTimeline                                                : "TopBarShowTimeline",
  TopBarShowUploads                                                 : "TopBarShowUploads",
  TravelRiskManagementContainerCloseAllow                           : "TravelRiskManagementContainerCloseAllow",
  TravelRiskManagementUseContainers                                 : "TravelRiskManagementUseContainers",
  UploadCentreAllowFileOverwrites                                   : "UploadCentreAllowFileOverwrites",
  UploadCentreAllowWebImageOverwrites                               : "UploadCentreAllowWebImageOverwrites",
  UsageLimitCompany                                                 : "UsageLimitCompany",
  UsageLimitCompanyCurrencyCode                                     : "UsageLimitCompanyCurrencyCode",
  UsageLimitCompanySelfAuth                                         : "UsageLimitCompanySelfAuth",
  UseGreyPageBackground                                             : "UseGreyPageBackground",
  UseServerSidePaging                                               : "UseServerSidePaging",
  UseServerSidePagingAudit                                          : "UseServerSidePagingAudit",
  UseServerSidePagingAuditErrorsOnly                                : "UseServerSidePagingAuditErrorsOnly",
  UseServerSidePagingAvailableSims                                  : "UseServerSidePagingAvailableSims",
  UseServerSidePagingInviewUsersEmbedded                            : "UseServerSidePagingInviewUsersEmbedded",
  UseServerSidePagingOrders                                         : "UseServerSidePagingOrders",
  UseServerSidePagingOrdersHistory                                  : "UseServerSidePagingOrdersHistory",
  UseServerSidePagingSignalsBreachExposure                          : "UseServerSidePagingSignalsBreachExposure",
  UseServerSidePagingSignalsCorporateHealth                         : "UseServerSidePagingSignalsCorporateHealth",
  UseServerSidePagingSignalsDeviceVulnerabilities                   : "UseServerSidePagingSignalsDeviceVulnerabilities",
  UseServerSidePagingTeamsCallRecords                               : "UseServerSidePagingTeamsCallRecords",
  UseServerSidePagingTeamsPresenceRecords                           : "UseServerSidePagingTeamsPresenceRecords",
  UseServerSidePagingUserSessions                                   : "UseServerSidePagingUserSessions",
  UtelizeHighAccess                                                 : "UtelizeHighAccess",
  VersionSureSimPollingCheckMilliSecs                               : "VersionSureSimPollingCheckMilliSecs",
  WebbingSuppressOriginalError                                      : "WebbingSuppressOriginalError",
  WidgetRow_IncludeCountsInLegend_MdmDevices01                      : "WidgetRow_IncludeCountsInLegend_MdmDevices01",
  WidgetRow_IncludeCountsInLegend_MdmDevices03                      : "WidgetRow_IncludeCountsInLegend_MdmDevices03",
  WidgetRow_MaxChartHeight_MdmDevices01                             : "WidgetRow_MaxChartHeight_MdmDevices01",
  WidgetRow_MaxChartHeight_MdmDevices02                             : "WidgetRow_MaxChartHeight_MdmDevices02",
  WidgetRow_MaxChartHeight_MdmDevices03                             : "WidgetRow_MaxChartHeight_MdmDevices03",
  WidgetRow_MaxWidgetsPerRow_Alerts                                 : "WidgetRow_MaxWidgetsPerRow_Alerts",
  WidgetRow_MaxWidgetsPerRow_Licences                               : "WidgetRow_MaxWidgetsPerRow_Licences",
  WidgetRow_MaxWidgetsPerRow_MdmDevices01                           : "WidgetRow_MaxWidgetsPerRow_MdmDevices01",
  WidgetRow_MaxWidgetsPerRow_MdmDevices02                           : "WidgetRow_MaxWidgetsPerRow_MdmDevices02",
  WidgetRow_MaxWidgetsPerRow_MdmDevices03                           : "WidgetRow_MaxWidgetsPerRow_MdmDevices03",
  WidgetRow_MaxWidgetsPerRow_MdmDevices04                           : "WidgetRow_MaxWidgetsPerRow_MdmDevices04",
  WidgetRow_MaxWidgetsPerRow_SimProfit                              : "WidgetRow_MaxWidgetsPerRow_SimProfit",
  WidgetRow_MaxWidgetsPerRow_Sims                                   : "WidgetRow_MaxWidgetsPerRow_Sims",
  WidgetRow_MaxWidgetsPerRow_TotalCosts                             : "WidgetRow_MaxWidgetsPerRow_TotalCosts",
  WidgetRow_MaxWidgetsPerRow_TotalCostsProfit                       : "WidgetRow_MaxWidgetsPerRow_TotalCostsProfit",
  WidgetRow_MaxWidgetsPerRow_Usage                                  : "WidgetRow_MaxWidgetsPerRow_Usage",
  WidgetRow_MdmDevices04_Show_OldestDevice                          : "WidgetRow_MdmDevices04_Show_OldestDevice",
  WidgetRow_MdmDevices04_Show_UsersMoreThanOneDeviceSameType        : "WidgetRow_MdmDevices04_Show_UsersMoreThanOneDeviceSameType",
  WidgetRow_Polling_Alerts                                          : "WidgetRow_Polling_Alerts",
  WidgetRow_Polling_Compliance_MdmDevices01                         : "WidgetRow_Polling_Compliance_MdmDevices01",
  WidgetRow_Polling_Compliance_MdmDevices02                         : "WidgetRow_Polling_Compliance_MdmDevices02",
  WidgetRow_Polling_Licences                                        : "WidgetRow_Polling_Licences",
  WidgetRow_Polling_MdmDevices01                                    : "WidgetRow_Polling_MdmDevices01",
  WidgetRow_Polling_MdmDevices02                                    : "WidgetRow_Polling_MdmDevices02",
  WidgetRow_Polling_MdmDevices03                                    : "WidgetRow_Polling_MdmDevices03",
  WidgetRow_Polling_MdmDevices04                                    : "WidgetRow_Polling_MdmDevices04",
  WidgetRow_Polling_SimProfit                                       : "WidgetRow_Polling_SimProfit",
  WidgetRow_Polling_TotalCosts                                      : "WidgetRow_Polling_TotalCosts",
  WidgetRow_Polling_TotalCostsProfit                                : "WidgetRow_Polling_TotalCostsProfit",
  WidgetRow_Polling_Usage                                           : "WidgetRow_Polling_Usage",
  WidgetRow_Title_Alerts                                            : "WidgetRow_Title_Alerts",
  WidgetRow_Title_Alerts_AdminOverview                              : "WidgetRow_Title_Alerts_AdminOverview",
  WidgetRow_Title_Licences                                          : "WidgetRow_Title_Licences",
  WidgetRow_Title_Licences_AdminOverview                            : "WidgetRow_Title_Licences_AdminOverview",
  WidgetRow_Title_MdmDevices01_MdmDashboard                         : "WidgetRow_Title_MdmDevices01_MdmDashboard",
  WidgetRow_Title_MdmDevices01_MdmDeviceCompliance                  : "WidgetRow_Title_MdmDevices01_MdmDeviceCompliance",
  WidgetRow_Title_MdmDevices02_MdmDashboard                         : "WidgetRow_Title_MdmDevices02_MdmDashboard",
  WidgetRow_Title_MdmDevices02_MdmDeviceCompliance                  : "WidgetRow_Title_MdmDevices02_MdmDeviceCompliance",
  WidgetRow_Title_MdmDevices03_MdmDashboard                         : "WidgetRow_Title_MdmDevices03_MdmDashboard",
  WidgetRow_Title_MdmDevices04_MdmDashboard                         : "WidgetRow_Title_MdmDevices04_MdmDashboard",
  WidgetRow_Title_ProfitUsage                                       : "WidgetRow_Title_ProfitUsage",
  WidgetRow_Title_ProfitUsage_AdminOverview                         : "WidgetRow_Title_ProfitUsage_AdminOverview",
  WidgetRow_Title_SimProfit_AdminOverview                           : "WidgetRow_Title_SimProfit_AdminOverview",
  WidgetRow_Title_Sims                                              : "WidgetRow_Title_Sims",
  WidgetRow_Title_Sims_AdminOverview                                : "WidgetRow_Title_Sims_AdminOverview",
  WidgetRow_Title_TotalCosts                                        : "WidgetRow_Title_TotalCosts",
  WidgetRow_Title_TotalCosts_AdminOverview                          : "WidgetRow_Title_TotalCosts_AdminOverview",
  WidgetRow_UsageDashboard_ShowRegionHighlightOnMapHover            : "WidgetRow_UsageDashboard_ShowRegionHighlightOnMapHover",
  WidgetRow_UsageDashboard_ShowRiskColourMap                        : "WidgetRow_UsageDashboard_ShowRiskColourMap",
}

export const ConfigSystemParamDefaults = {
  CookieRememberMeExpiryDays    : 30,
  InviewUserListLimit           : 200,
  LoginCookieWarningShow        : true,
  MdmDeviceEndOfLifePrecision   : "dd/mm/yyyy",
  MdmDeviceEndOfSupportPrecision: "dd/mm/yyyy",
}

export const CookieKeys = {
  IsSso     : "IsSso",
  Language  : "lang",
  RememberMe: "RememberMe",
  Username  : "Username",
}

export const CostCentreAutoLevels = {
  Level1: "Level 1 Unallocated",
  Level2: "Level 2 SureSIM",
}

export const CurrencyPositions = {
  Left : "Left",
  Right: "Right",
}

//#region Dashboard

export const DashboardProfit = {
  Equal: "equal",
  Down : "down",
  Up   : "up", 
}

//#endregion

export const DatePrecisionAcceptedValues: string[]=["dd/mm/yyyy", "mm/yyyy", "yyyy"];

export const Duration = {
  _1MinMilli : 60000,
  _4MinMilli : 240000,
  _5MinMilli : 300000,
  _30MinMilli: 1800000,
  _1SecMilli : 1000,
  _5SecMilli : 5000,
}

export const ErrorCodes = {
  SignedTokenExpired: "SIGNED_TOKEN_EXPIRED",
}

export const ErrorStrings = {
  AccessDenied            : "You do not have access to this page",
  AllRecipientsCeased     : "All recipients belong to ceased companies",
  AccessNotLicensed       : "Your company is not licensed for this feature, please contact your account manager",
  AccountIsLocked         : "Login Account is Locked",
  CannotBeFound           : "cannot be found",
  InvalidMicrosoftToken   : "Invalid Microsoft token",
  NoError                 : "No Error",
  OriginalWebbingError    : "An error has occured",
  RecipientLimitExceeded  : "RecipientLimitExceeded",
  ReplacementWebbingError : "Network details are not available at this time, possibly due to an unprovisioned status. Please try again later.",
  SecurityTokenMissing    : "A security Token has not been provided",
  SecurityTokenSessionEnd : "The current session has ended",
  SignalsNotCovered       : "SIGNALS_NOT_COVERED",
  SignedTokenExpired      : "This view's security token expired while the page was open. Please refresh and try again.",
  StatementBatchInProgress: "batch run is already in progress",
  UsernameAlreadyInUse    : "is already in use by another active user",
}

export const FieldAliases = {
  FieldAliasUsername: "Assigned To",
  FieldAliasTag     : "User Ref 1",
  FieldAliasTag2    : "USer Ref 2",
}

//#region DataGrid

export const DgActionColumnWidth = {
  messageButton                   : 73,
  oneButton                       : 60,
  oneButtonWithLeftRightPadding   : 80,
  twoButtonsWithLeftRightPadding  : 138,
  threeButtonsWithLeftRightPadding: 196,
}

export const DgAlignment = {
  center: "center",
  left  : "left",
  right : "right",
}

export const DgColumnChooserMode = {
  dragAndDrop: "dragAndDrop",
  select     : "select",
}

export const DgColumnDataType = {
  boolean  : "boolean",
  currency : "currency",
  datalist : "datalist",
  date     : "date",
  datetime : "datetime",
  decimal  : "decimal",
  number   : "number",
  object   : "object",
  string   : "string",
}

export const DgColumnSortOrder = {
  asc  : "asc",
  desc : "desc",
} as const;

export type DgColumnSortOrder = typeof DgColumnSortOrder[keyof typeof DgColumnSortOrder];

export const DgColumnWidths = {
  active      : 90,
  companyName : 225,
  date        : 100,
  dateWithTime: 150,
  email       : 250,
  featureqty  : 90,
  firstName   : 150,
  fullname    : 175,
  HHmmssfff   : 100,
  iccic       : 170,
  id          : 90,
  imei        : 135,
  languageCode: 95,
  latLong     : 95,
  licenceQty  : 95,
  megabytes   : 200,
  mobileNumber: 120,
  money       : 200,
  price       : 100,
  product     : 300,
  orderNo     : 120,
  numberShort : 90,
  numberMedium: 115,
  simStatus   : 210,
  surname     : 150,
  systemOwned : 125,
  tag         : 150,
  timeZone    : 150,
  username    : 250
}

export const DgEditingMode = {
  batch: "batch",
  cell : "cell",
  form : "form",
  popup: "popup",
  row  : "row",
}

export const DgExportFormat = {
  pdf : "pdf",
  xlsx: "xlsx",
}

export const DgFormLabelLocation = {
  left : "left",
  right: "right",
  top  : "top",
}

export const DgFormValidationRule = {
  async       : "async",
  compare     : "compare",
  custom      : "custom",
  email       : "email",
  none        : "none",
  numeric     : "numeric",
  pattern     : "pattern",
  range       : "range",
  required    : "required",
  stringLength: "stringLength",
}
        
export const DgPagerDisplayMode = {
  adaptive: "adaptive",
  compact : "compact",
  full    : "full",
}

export const DgPagerScrollingMode = {
  infinite: "infinite",
  standard: "standard",
  virtual : "virtual",
}

export const DgPopupDefaults = {
  colSpan: 2,
  height : 500,
  width  : 500,
}

export const DgSelectionCheckBoxMode = {
  always   : "always",
  none     : "none",
  onClick  : "onClick",
  onLongTap: "onLongTap",
}

export const DgSelectionMode = {
  multiple: "multiple",
  none    : "none",
  single  : "single",
}

export const DgSummaryType = {
  avg  : "avg",
  count: "count",
  max  : "max",
  min  : "min",
  none : "none",
  sum  : "sum",
}

export const DxIcon = {
  add : "add",
  none: "",
}

export const DxText = {
  add   : "Add",
  delete: "Delete",
  none  : "",
}

export const DxType = {
  back   : "back",
  danger : "danger",
  default: "default",
  normal : "normal",
  success: "success",
}

//#endregion

export const eSimApiPaths = {
  AccountManagers                                                        : "AccountManagers",
  AccountManagersIdAndDescription                                        : "IdAndDescription",
  AccountManagersPhoto                                                   : "Photo",
  Addresses                                                              : "Addresses",
  AddressesGetPostcode                                                   : "GetPostcode",
  AddressesPostcodeSearch                                                : "PostcodeSearch",
  AddTicketComment                                                       : "AddTicketComment",
  AddTicketReply                                                         : "AddTicketReply",
  AlertCreateNewAlertByTemplateId                                        : "CreateNewAlertByTemplateId",
  AlertDefaultTemplates                                                  : "GetAlertDefaultTemplates",
  Alerts                                                                 : "Alert",
  AlertsDelete                                                           : "DeleteAlert",
  AlertsGetAllCountriesForAlert                                          : "GetAllCountriesForAlert",
  AlertsGetById                                                          : "GetAlert",
  AlertsGetCountries                                                     : "GetCompanyAlertCountries",
  AlertsGetDevices                                                       : "GetAlertDevices",
  AlertsOptOut                                                           : "AlertOptOut",
  AlertsPost                                                             : "PostAlert",
  AlertsPut                                                              : "PutAlert",
  AlertsToggleActiveState                                                : "ToggleAlertState",
  AlertsTriggered                                                        : "AlertsTriggered",
  AlertsTriggeredGetDeviceTriggeredAlerts                                : "GetDeviceTriggeredAlerts",
  AlertsTriggeredGetTriggeredAlerts                                      : "GetTriggeredAlerts",
  Assistant                                                              : "Assistant",
  AssistantSearch                                                        : "Search",
  Audit                                                                  : "Audit",
  AuditCompanySummary                                                    : "GetAuditCompanySummary",
  AuditDistinctUsersTodayServerSide                                      : "GetAuditDistinctUsersTodayServerSide",
  AuditGetStats                                                          : "GetStats",
  AuditInsights                                                          : "AuditInsights",
  AuditInsightsGetDormantUsers                                           : "GetDormantUsers",
  AuditInsightsGetEngagementRisk                                         : "GetEngagementRisk",
  AuditInsightsGetFunctions                                              : "GetFunctions",
  AuditInsightsGetHeatmap                                                : "GetHeatmap",
  AuditInsightsGetHeatmapUsers                                           : "GetHeatmapUsers",
  AuditInsightsGetPageUsers                                              : "GetPageUsers",
  AuditInsightsGetSummary                                                : "GetSummary",
  AuditInsightsGetTopCompanies                                           : "GetTopCompanies",
  AuditInsightsGetTopFunctions                                           : "GetTopFunctions",
  AuditInsightsGetTopPages                                               : "GetTopPages",
  AuditInsightsGetTopUsers                                               : "GetTopUsers",
  AuditInsightsGetTrend                                                  : "GetTrend",
  AuditInsightsLogPageViews                                              : "LogPageViews",
  AuditInsightsUpdateFunction                                            : "UpdateFunction",
  AuditLogBrowserInfo                                                    : "LogBrowserInfo",
  AuditLogBrowserInfoAnonymous                                           : "LogBrowserInfoAnonymous",
  AuditServerSide                                                        : "GetAuditServerSide",
  AuditServerSideErrorsOnly                                              : "GetAuditErrorsOnlyServerSide",
  ChatGpt                                                                : "ChatGpt",
  ChatGptViaAzureOpenAi                                                  : "Ask",
  CommConfig                                                             : "CommConfig",
  CommConfigCompanyCommTemplatesDefaults                                 : "GetCompanyCommunicationTemplatesDefaults",
  CommConfigCompanyDefaultTemplates                                      : "GetCompanyDefaultTemplates",
  CommConfigCompanyUnallocatedTemplates                                  : "GetCompanyUnallocatedTemplates",
  CommConfigCreateCommunicationTemplate                                  : "CreateCommunicationTemplate",
  CommConfigCreateCompanyCommunicationTemplateDefaults                   : "CreateCompanyCommunicationTemplateDefaults",
  CommConfigEditCommunicationTemplate                                    : "EditCommunicationTemplate",
  CommConfigEnableCompanyTemplate                                        : "EnableCompanyTemplate",
  CommConfigForCompany                                                   : "ForCompany",
  CommConfigForCompanyAlert                                              : "ForCompanyAlert",
  CommConfigSendTestCommunications                                       : "SendTestCommunicationForTemplate",
  CommConfigUpdateCompanyCommConfigs                                     : "UpdateCompanyCommConfigs",
  Communications                                                         : "Communications",
  CommunicationsCompose                                                  : "CommunicationCompose",
  CommunicationsDeliveryResults                                          : "DeliveryResults",
  CommunicationsForCompany                                               : "ForCompany",
  CommunicationsForSingleUser                                            : "ForSingleUser",
  CommunicationsForUser                                                  : "ForUser",
  CommunicationsForUserActiveOnly                                        : "ForUserActiveOnly",
  CommunicationsForUserIncludeLegacySms                                  : "ForUserIncludeLegacySms",
  CommunicationsMarkAsRead                                               : "MarkAsRead",
  CommunicationsMarkAsUnread                                             : "MarkAsUnread",
  Companies                                                              : "Companies",
  CompaniesCanCreateCompanyUnder                                         : "CanCreateCompanyUnder",
  CompaniesCease                                                         : "Cease",
  CompaniesForUser                                                       : "ForUser",
  CompaniesGetChildrenCreditLimitBreaches                                : "GetChildrenCreditLimitBreaches",
  CompaniesGetSsoIdsEncrypted                                            : "GetSsoIdsEncrypted",
  CompaniesParentCreditLimit                                             : "ParentCreditLimit",
  CompaniesSuperHierarchyIdDescription                                   : "SuperHierarchyIdDescription",
  //CompaniesUncease                                                       : "Uncease", //CRN_20261021 - Retired
  CompaniesUndelete                                                      : "Undelete",
  CompanyAlerts                                                          : "GetCompanyAlerts",
  CompanyFiles                                                           : "CompanyFiles",
  CompanyFilesGetFileByCompanyIdAndCompanyFileTypeId                     : "GetFileByCompanyIdAndCompanyFileTypeId",
  CompanyFilesGetFileById                                                : "GetFileById",
  CompanyFilesUpload                                                     : "Upload",
  CompanyHierachy                                                        : "CompanyHierachy",
  CompanyHierachyGetCompanyParentId                                      : "GetCompanyParentID",
  CompanyKillCompany                                                     : "KillCompany",
  CompanyPortalAccess                                                    : "CompanyPortalAccess",
  CompanyUsageLimits                                                     : "CompanyUsageLimits",
  CompanyUsageLimitsForCompany                                           : "ForCompany",
  ComponentAccess_Base                                                   : "ComponentAccess_Base",
  ComponentAccess_Base_GetAll                                            : "GetAll",
  ComponentAccess_Company                                                : "ComponentAccess_Company",
  ComponentAccess_Company_GetAll                                         : "GetAll",
  ComponentAccess_Company_Actual                                         : "ComponentAccess_Company_Actual",
  ComponentAccess_Company_Actual_GetAllForLoggedInUser                   : "GetAllForLoggedInUser",
  ComponentAccess_Company_Actual_HomeGuardState                          : "HomeGuardState",
  ComponentAccess_Company_Actual_SetHomeGuard                            : "SetHomeGuard",
  ComponentAccess_User                                                   : "ComponentAccess_User",
  ComponentAccess_User_Actual                                            : "ComponentAccess_User_Actual",
  ComponentAccess_User_Actual_GetAllForLoggedInUser                      : "GetAllForLoggedInUser",
  ComponentAccess_User_Actual_HomeGuardState                             : "HomeGuardState",
  ComponentAccess_User_Actual_SetHomeGuard                               : "SetHomeGuard",
  ComponentAccess_User_Actual_ClearHomeGuard                             : "ClearHomeGuard",
  ComponentAccess_User_GetAllForLoggedInUser                             : "GetAllForLoggedInUser",
  ComponentAccess_UserAndCompanyDefaults                                 : "WithCompanyDefaults",
  ConfigSystem                                                           : "ConfigSystem",
  ConfigSystemEncrypted                                                  : "GetConfigSystemEncrypted",
  ConfigSystemServerSide                                                 : "GetConfigSystemServerSide",
  Countries                                                              : "Countries",
  CountryGroups                                                          : "CountryGroups",
  CountryGroupsDeleteCountryAllocation                                   : "DeleteCountryAllocation",
  CountryGroupsDeleteCountryGroup                                        : "DeleteCountryGroup",
  CountryGroupsGetAllCountriesForGroupId                                 : "GetAllCountriesForGroupId",
  CountryGroupsGetAllGroupsForAlert                                      : "GetAllGroupsForAlert",
  CountryGroupsGetCountryGroupById                                       : "GetCountryGroupById",
  CountryGroupsGetCountryGroupsForCompany                                : "GetCountryGroupsForCompany",
  CountryGroupsPost                                                      : "PostCountryGroup",
  CountryGroupsPut                                                       : "PutCountryGroup",
  CreditLimitAlertRecipients                                             : "CreditLimitAlertRecipients",
  CreditLimitManagement                                                  : "CreditLimitManagement",
  CreditLimitManagementDailySpendReportManual                            : "DailySpendReportManual",
  CreditLimitManagementEnforcedConnections                               : "EnforcedConnections",
  CreditLimitManagementEvaluateManual                                    : "EvaluateCreditLimitsManual",
  CreditLimitManagementGetParents                                        : "GetParents",
  CreditLimitManagementResetMonthManual                                  : "ResetMonthManual",
  CreditLimitManagementRefresh                                           : "RefreshCompany",
  Crypto                                                                 : "Crypto",
  CryptoEncryptAesServerSideForWeb                                       : "EncryptAesServerSideForWeb",
  Dashboard                                                              : "Dashboard",
  DashboardGetAlertsTimesTriggeredCountry                                : "GetAlertsTimesTriggeredCountry",
  DashboardGetAlertsTimesTriggeredUsage                                  : "GetAlertsTimesTriggeredUsage",
  DashboardGetAlertsTotalLimitIncreases                                  : "GetAlertsTotalLimitIncreases",
  DashboardGetAlertsTotalThrottles                                       : "GetAlertsTotalThrottles",
  DashboardGetCostsPerZone                                               : "GetCostsPerZone",
  DashboardGetCustomerOverview                                           : "GetCustomerOverview",
  DashboardGetSimStatuses                                                : "GetSimStatuses",
  DashboardGetTotalAvailableeSimCount                                    : "GetTotalAvailableeSimCount",
  DashboardGetTotalAvailableSimCount                                     : "GetTotalAvailableSimCount",
  DashboardGetTotalCompaniesCount                                        : "GetTotalCompaniesCount",
  DashboardGetTotalCosts                                                 : "GetTotalCosts",
  DashboardGetTotalCostsProfit                                           : "GetTotalCostsProfit",
  DashboardGetTotalCostsPurchase                                         : "GetTotalCostsPurchase",
  DashboardGetTotalCostsUsageAndLicence                                  : "GetTotalUsageAndLicenceCosts",
  DashboardGetTotalLicenceCosts                                          : "GetTotalLicenceCosts",
  DashboardGetTotalPlatformLicenceCount                                  : "GetTotalPlatformLicenceCount",
  DashboardGetTotalPlatformLicencesLiveButEnded                          : "GetTotalPlatformLicencesLiveButEnded",
  DashboardGetTotalPlatformLicencesUnused                                : "GetTotalPlatformLicencesUnused",
  DashboardGetTotalReservedeSimCount                                     : "GetTotalReservedeSimCount",
  DashboardGetTotalReservedSimCount                                      : "GetTotalReservedSimCount",
  DashboardGetTotalSimCount                                              : "GetTotalSimCount",
  DashboardGetTotalSimProfit                                             : "GetTotalSimProfit",
  DashboardGetTotalSimProfitLicenceCosts                                 : "GetTotalSimProfitLicenceCosts",
  DashboardGetTotalSimProfitPurchaseCosts                                : "GetTotalSimProfitPurchaseCosts",
  DashboardGetTotalUsage                                                 : "GetTotalUsage",
  DashboardGetUserWithMostCost                                           : "GetUserWithMostCost",
  DeleteCompanyCommunicationTemplate                                     : "DeleteCompanyCommunicationTemplate",
  DeviceAlerts                                                           : "GetDeviceAlerts",
  DeviceAllocate                                                         : "Allocate",
  DeviceGetNextAvailable                                                 : "GetNextAvailable",
  Devices                                                                : "Devices",
  DevicesByImeiIccid                                                     : "GetDeviceByImeiIccid",
  DevicesEnableLocationServices                                          : "EnableLocationServices",
  DevicesForCompany                                                      : "DevicesForCompany",
  DevicesForHierarchy                                                    : "DevicesForHierarchy",
  DevicesForUser                                                         : "DevicesForUser",
  DevicesGetAvailable                                                    : "GetAvailableSims",
  DevicesGetAvailableServerSide                                          : "GetAvailableSimsServerSide",
  DevicesGetById                                                         : "GetById",
  DevicesToggleLocationServices                                          : "ToggleLocationServices",
  DevicesTotalLiveDevicesForCompany                                      : "TotalLiveDevicesForCompany",
  DevicesUpdateDeviceTag                                                 : "UpdateDeviceTag",
  DevicesUpdateLocationSettings                                          : "UpdateLocationSettings",
  DownloadableFiles                                                      : "DownloadableFiles",
  DownloadableFilesGetFileById                                           : "GetFileById",
  DownloadableFilesUpload                                                : "Upload",
  ExistsByCompanyID                                                      : "ExistsByCompanyID",
  ExistsOnEsp                                                            : "ExistsOnEsp",
  FinancialPeriods                                                       : "FinancialPeriods",
  FinancialReports                                                       : "FinancialReports",
  FinancialReportsForReseller                                            : "FinancialReportsForReseller",
  FinancialsCostSummary                                                  : "CostSummary",
  Financials                                                             : "Financials",
  FinancialsGetFinancialsDateRange                                       : "GetFinancialsDateRange",
  GetBandsForTariff                                                      : "GetBandsForTariff",
  GetCommunicationTemplateReplacements                                   : "GetCommunicationTemplateReplacements",
  GetCompanyAlertCommunicationTemplates                                  : "GetCompanyAlertCommunicationTemplates",
  GetCompanyCommunicationTemplate                                        : "GetCompanyCommunicationTemplate",
  GetCompanyCommunicationTemplates                                       : "GetCompanyCommunicationTemplates",
  GetIdByBandLevelValue                                                  : "GetIdByBandLevelValue",
  GetIdByCompanyId                                                       : "GetIdByCompanyId",
  GetIdByCompanyIdAndFullname                                            : "GetIdByCompanyIdAndFullname",
  GetIdByCompanyName                                                     : "GetIdByCompanyName",
  GetIdByLicenceName                                                     : "GetIdByLicenceName",
  GetIdByUsername                                                        : "GetIdByUsername",
  GetInviewCompanyId                                                     : "GetInviewCompanyId",
  GetMaxBandLevelValue                                                   : "GetMaxBandLevelValue",
  GetOrderDataSessions                                                   : "GetOrderDataSessions",
  GetOrderDataSessionsByDate                                             : "GetOrderDataSessionsByDate",
  GetOrderIdByIccid                                                      : "GetOrderIdByIccid",
  GetOrderIdByOrderNo                                                    : "GetOrderIdByOrderNo",
  GetOrderUsageLimitsOrDefaults                                          : "GetOrderUsageLimitsOrDefaults",
  GetOrderWithSpend                                                      : "GetOrderWithSpend",
  GetTicket                                                              : "GetTicket",
  GetTicketComments                                                      : "GetTicketComments",
  GetTickets                                                             : "GetTickets",
  GetUserAndCompanyTickets                                               : "GetUserAndCompanyTickets",
  GetUsersAssociate                                                      : "GetUsersAssociate",
  GetUsersESim                                                           : "GetUsersESim",
  GetUsersPortal                                                         : "GetUsersPortal",
  GridColumnState                                                        : "GridColumnState",
  HierarchyIdDescription                                                 : "HierarchyIdDescription",
  IdDescription                                                          : "IdDescription",
  Inventory                                                              : "Inventory",
  InventoryGetDeviceByAssetId                                            : "GetDeviceByAssetId",
  InventoryGetDeviceCountByAge                                           : "GetDeviceCountByAge",
  InventoryGetDeviceCountByModel                                         : "GetDeviceCountByModel",
  InventoryGetDeviceCountByStatus                                        : "GetDeviceCountByStatus",
  InventoryGetDeviceCountByWarrantyExpiry                                : "GetDeviceCountByWarrantyExpiry",
  InventoryGetDeviceExport                                               : "GetDeviceExport",
  InventoryGetDeviceRegistrationHistory                                  : "GetDeviceRegistrationHistory",
  InventoryGetDevicesServerSide                                          : "GetDevicesServerSide",
  InventoryGetLinkStatus                                                 : "GetLinkStatus",
  InviewApi                                                              : "InviewApi",
  InviewApiGetLastActiveCliData                                          : "GetLastActiveCLIData",
  InviewCompanies                                                        : "InviewCompanies",
  InviewCompaniesExcludeSureSimCompanies                                 : "ExcludeSureSimCompanies",
  InviewCostCentreGetParentID                                            : "GetParentID",
  InviewCostCentres                                                      : "InviewCostCentres",
  InviewGetCostCentreByName                                              : "GetCostCentreByName",
  InviewRegistration                                                     : "InviewRegistration",
  InviewRegistrationChangePassword                                       : "ChangePassword",
  InviewRegistrationLockUser                                             : "LockUser",
  InviewRegistrationLogout                                               : "Logout",
  InviewRegistrationResetPassword                                        : "ResetPassword",
  InviewRegistrationUnlockAdmin                                          : "UnlockAdmin",
  InviewRegistrationUnlockUser                                           : "UnlockUser",
  InviewRegistrationUserIsLocked                                         : "UserIsLocked",
  InviewUsers                                                            : "InviewUsers",
  InviewUsersClis                                                        : "InviewUsersClis",
  InviewUsersClisCliExistsOnDifferentUser                                : "CliExistsOnDifferentUser",
  InviewUsersExcludeSureSimEsimUsers                                     : "ExcludeSureSimEsimUsers",
  InviewUsersExcludeSureSimPortalUsers                                   : "ExcludeSureSimPortalUsers",
  InviewUsersExcludeSureSimUsersIncAssociates                            : "ExcludeSureSimUsersIncAssociates",
  InviewUsersGetCompanyUsersCount                                        : "GetCompanyUsersCount",
  InviewUsersGetUserById                                                 : "GetUserById",
  InviewUsersGetUsersServerSide                                          : "GetUsersServerSide",
  LicencesCompanyAllocated                                               : "LicencesCompanyAllocated",
  LicencesCompanyAllocatedCalculateCancellationDate                      : "CalculateCancellationDate",
  LicencesCompanyAllocatedCancelLicence                                  : "CancelLicence",
  LicencesCompanyAllocatedChangeQuantityAndStartDate                     : "ChangeQuantityAndStartDate",
  LicencesCompanyAllocatedCompanyHasLicenceBundle                        : "CompanyHasLicenceBundle",
  LicencesCompanyAllocatedCompanyHasLicenceFeature                       : "CompanyHasLicenceFeature",
  LicencesCompanyAllocatedCompanyHasLicenceFeatureByGuid                 : "CompanyHasLicenceFeatureByGuid",
  LicencesCompanyAllocatedCompanyHasLicencePlatform                      : "CompanyHasLicencePlatform",
  LicencesCompanyAllocatedCompanyHasLicenceUsage                         : "CompanyHasLicenceUsage",
  LicencesCompanyAllocatedCompanyHasLicenceUsageZoneOverlap              : "CompanyHasLicenceUsageZoneOverlap",
  LicencesCompanyAllocatedForHierarchy                                   : "GetLicencesCompanyHierarchyAllocated",
  LicencesCompanyAllocatedForSingleCompany                               : "GetLicencesCompanyAllocated",
  LicencesCompanyAllocatedTotalLivePlatformLicencesForCompany            : "TotalLivePlatformLicencesForCompany",
  LicencesCompanyAllocatedTotalLivePlatformLicencesForCompanyExcludeEnded: "TotalLivePlatformLicencesForCompanyExcludeEnded",
  LicencesCompanyVisible                                                 : "LicencesCompanyVisible",
  LicencesCompanyVisibleForHierarchy                                     : "GetLicencesCompanyHierarchyVisible",
  LicencesCompanyVisibleForSingleCompany                                 : "GetLicencesCompanyVisible",
  LicencesGetLicencesAndVisibilityMarkForCompany                         : "GetLicencesAndVisibilityMarkForCompany",
  LicencesSystem                                                         : "LicencesSystem",
  LicencesSystemGetLicencesSystem                                        : "GetLicencesSystem",
  LocationAwareness                                                      : "LocationAwareness",
  LocationAwarenessGetCompanyAccuracyChangeImpact                        : "GetCompanyAccuracyChangeImpact",
  LocationAwarenessGetStatus                                             : "GetStatus",
  LocationAwarenessSendConsentRequest                                    : "SendConsentRequest",
  LocationVisibilityChanges                                              : "LocationVisibilityChanges",
  LocationVisibilityChangesForCompany                                    : "ForCompany",
  LocationVisibilityChangesForSim                                        : "ForSim",
  LocationWebhookConfig                                                  : "LocationWebhookConfig",
  LocationWebhookConfigReplayLastCountryChange                           : "ReplayLastCountryChange",
  LocationWebhookConfigTestSend                                          : "TestSend",
  MappedCountries                                                        : "MappedCountries",
  MappedZones                                                            : "MappedZones",
  MappedZones_MapAndZone                                                 : "MappedZones_MapAndZone",
  MdmComplianceCampaigns                                                 : "MdmComplianceCampaigns",
  MdmComplianceCampaignsCompanyHasActiveCampaignConflict                 : "CompanyHasActiveCampaignConflict",
  MdmComplianceCampaignsMdmDeviceComplianceLogs                          : "MdmDeviceComplianceLogs",
  MdmComplianceCampaignStages                                            : "MdmComplianceCampaignStages",
  MdmDevices                                                             : "MdmDevices",
  MdmDevices_Company                                                     : "MdmDevices_Company",
  MdmDevices_CompanyConfig                                               : "MdmDevices_CompanyConfig",
  MdmDevices_CompanyConfigGetByCompanyID                                 : "GetByCompanyID",
  MdmDevicesIntune                                                       : "MdmDevicesIntune",
  MdmDevicesIntuneGetLatestMdmIntuneEnteredDate                          : "GetLatestMdmIntuneEnteredDate",
  MdmDevicesIntuneMdmDeviceNotificationLogs                              : "MdmDeviceNotificationLogs",
  MdmDevicesIntuneSendAllMdmDeviceComplianceCampaignCommunications       : "SendAllMdmDeviceComplianceCampaignCommunications",
  MdmDevicesIntuneSendAllMdmDeviceRemediationCommunications              : "SendAllMdmDeviceRemediationCommunications",
  MdmDevicesIntuneSendCommunications                                     : "SendCommunications",
  MdmDevicesIntuneSendComplianceCampaignStage                            : "SendComplianceCampaignStage",
  MdmDevicesIntuneStats                                                  : "MdmDevicesIntuneStats",
  MdmDevicesIntuneStatsGetSyncedByInfo_Latest                            : "GetSyncedByInfo_Latest",
  MdmDevicesIntuneStatsGetSyncedByInfo_Previous                          : "GetSyncedByInfo_Previous",
  MdmDevicesIntuneUpdateMdmStatusTypes                                   : "UpdateMdmStatusTypes",
  MdmDevicesIntuneUserDomains                                            : "UserDomains",
  MdmDevicesTemplatesCommunication                                       : "MdmDevicesTemplatesCommunication",
  MdmIntune                                                              : "Intune",
  MdmIntuneCanConnect                                                    : "CanConnect",
  MdmIntuneCanConnectTestAllForHierarchy                                 : "CanConnectTestAllForHierarchy",
  MdmIntuneImportDeviceCsv                                               : "ImportDeviceCsv",
  MdmIntuneImportUserCsv                                                 : "ImportUserCsv",
  MdmIntuneSimExceptions                                                 : "MdmIntuneSimExceptions",
  MdmIntuneSimExceptionsIntuneDevices                                    : "IntuneDevices",
  MdmIntuneSyncAllDevices                                                : "SyncAllDevices",
  MdmIntuneSyncDevices                                                   : "SyncDevices",
  MdmIntuneSyncDevicesForHierarchy                                       : "SyncDevicesForHierarchy",
  MdmIntuneSyncManagedDevicesToDb                                        : "SyncManagedDevicesToDb",
  MdmIntuneSyncManagedDevicesToDbForHierarchy                            : "SyncManagedDevicesToDbForHierarchy",
  MdmIntuneSyncUsersToDb                                                 : "SyncUsersToDb",
  MdmIntuneSyncUsersToDbForHierarchy                                     : "SyncUsersToDbForHierarchy",
  MdmIntuneTestAllIntuneConnections                                      : "TestAllIntuneConnections",
  MdmUsersIntune                                                         : "MdmUsersIntune",
  Messages                                                               : "Messages",
  MessagesGetById                                                        : "GetById",
  MessagesGetCompany                                                     : "ForCompany",
  MessagingApiKeys                                                       : "MessagingApiKeys",
  MessagingApiRequestLog                                                 : "MessagingApiRequestLog",
  Orders                                                                 : "Orders",
  OrdersActiveOnly                                                       : "ActiveOnly",
  OrdersActiveOnlyServerSide                                             : "ActiveOnlyServerSide",
  OrdersBulk                                                             : "GetBulkOrders",
  OrdersBulkById                                                         : "GetBulkOrderById",
  OrdersBulkDelete                                                       : "DeleteBulkOrder",
  OrdersBulkDeleteById                                                   : "DeleteBulkOrderById",
  OrdersBulkPost                                                         : "PostBulkOrder",
  OrdersBulkPut                                                          : "PutBulkOrder",
  OrdersBulkSummaries                                                    : "GetBulkOrdersSummary",
  OrdersBulkSummary                                                      : "GetBulkOrderSummary",
  OrdersBulkTotalInvalidCount                                            : "GetTotalInvalidCount",
  OrdersBulkTotalProvisionedCount                                        : "GetTotalProvisionedCount",
  OrdersBulkTotalRequestsCount                                           : "GetTotalRequestsCount",
  OrdersBulkTotalValidCount                                              : "GetTotalValidCount",
  OrdersBulkUpload                                                       : "PostBulkOrders",
  OrdersBulkValidateOrder                                                : "ValidateBulkOrder",
  OrdersGetById                                                          : "GetById",
  OrdersGetHistoricProducts                                              : "GetHistoricProducts",
  OrdersGetStats                                                         : "GetStats",
  OrdersGetStatus                                                        : "GetOrderStatus",
  OrdersPut                                                              : "PutOrder",
  OrdersPutCurrentMonthLimit                                             : "PutOrderCurrentMonthLimit",
  PartnerClientLinks                                                     : "PartnerClientLinks",
  PartnerClientLinksEnd                                                  : "End",
  Products                                                               : "Products",
  ProductsAvailableForSelection                                          : "Available",
  Reports                                                                : "Reports",
  RiskIntelligence                                                       : "risk-intelligence",
  RiskIntelligenceAdvisories                                             : "advisories",
  RiskIntelligenceAlerts                                                 : "alerts",
  RiskIntelligenceCityReports                                            : "city-reports",
  RiskIntelligenceCollections                                            : "collections",
  RiskIntelligenceCountryReports                                         : "country-reports",
  RiskIntelligenceCountryRiskLevels                                      : "country-risk-levels",
  RiskIntelligenceLocalRiskLevels                                        : "local-risk-levels",
  RiskIntelligencePtas                                                   : "pre-travel-advisories",
  RiskIntelligenceSta                                                    : "specific-traveller-advice",
  RiskIntelligenceSummaries                                              : "summaries",
  RiskIntelligenceTravelRiskArrivals                                     : "travel-risk/arrivals",
  RiskIntelligenceTravelRiskFeed                                         : "travel-risk/feed",
  RiskIntelligenceTravelRiskMessageActivity                              : "travel-risk/message-activity",
  RiskIntelligenceTravelRiskOfflineAlerts                                : "travel-risk/offline-alerts",
  RiskIntelligenceTravelRiskOfflineAlertsClosed                          : "travel-risk/offline-alerts/closed",
  RiskIntelligenceTravelRiskSummary                                      : "travel-risk/summary",
  RiskIntelligenceTravelRiskWelfare                                      : "travel-risk/welfare",
  RiskIntelligenceUsageReport                                            : "usage-report",
  RiskIntelligenceUsageReportSnapshot                                    : "usage-report/snapshot",
  RiskIntelligenceUserEntitlements                                       : "user-entitlements",
  RiskIntelligenceUserEntitlementsRevoke                                 : "user-entitlements/revoke",
  RiskIntelligenceUserEntitlementsSeatCount                              : "user-entitlements/seat-count",
  RiskIntelligenceTravelSearch                                           : "travel-search",
  RiskIntelligenceTripReady                                              : "trip-ready",
  RiskIntelligenceTripReadyLanding                                       : "trip-ready/landing-url",
  Signals                                                                : "signals",
  SignalsBreachExposure                                                  : "breach-exposure",
  SignalsBreachExposureServerSide                                        : "breach-exposure/server-side",
  SignalsBreachExposureSummary                                           : "breach-exposure/summary",
  SignalsCorporateHealth                                                 : "corporate-health",
  SignalsCorporateHealthByCompany                                        : "corporate-health/company",
  SignalsCorporateHealthServerSide                                       : "corporate-health/server-side",
  SignalsCorporateHealthSummary                                          : "corporate-health/summary",
  SignalsDashboardSummary                                                : "dashboard/summary",
  SignalsDeviceVulnerabilities                                           : "device-vulnerabilities",
  SignalsDeviceVulnerabilitiesServerSide                                 : "device-vulnerabilities/server-side",
  SignalsDeviceVulnerabilitiesSummary                                    : "device-vulnerabilities/summary",
  SignalsFeedStatus                                                      : "feed-status",
  SignalsTravelRiskAdvisories                                            : "travel-risk/advisories",
  SignalsTravelRiskAlerts                                                : "travel-risk/alerts",
  SignalsTravelRiskCityReport                                            : "travel-risk/city-report",
  SignalsTravelRiskComparison                                            : "travel-risk/comparison",
  SignalsTravelRiskCountryReport                                         : "travel-risk/country-report",
  SignalsTravelRiskCountryRiskLevels                                     : "travel-risk/country-risk-levels",
  SignalsTravelRiskExposure                                              : "travel-risk/exposure",
  SignalsTravelRiskTripBrief                                             : "travel-risk/trip-brief",
  Statements                                                             : "Statements",
  StatementsDownloadStatement                                            : "DownloadStatement",
  StatementsDownloadStatementCsv                                         : "DownloadStatementCsv",
  StatementsGenerateStatement                                            : "GenerateStatement",
  StatementsGenerateStatementsForHierarchy                               : "GenerateStatementsForHierarchy",
  StatementsGetCompanyStatement                                          : "GetCompanyStatement",
  StatementsGetStatementBatchStatus                                      : "GetStatementBatchStatus",
  StatementsGetStatementVersions                                         : "GetStatementVersions",
  StatementsStatementExistsForMonth                                      : "StatementExistsForMonth",
  Suppliers                                                              : "Suppliers",
  SupportHelpMenuItemGetById                                             : "GetSupportHelpMenuItemById",
  SupportHelpMenuItemGetByTitle                                          : "GetSupportHelpMenuItemByTitle",
  SupportHelpMenuItemPost                                                : "PostSupportHelpMenuItem",
  SupportHelpMenuItemPut                                                 : "PutSupportHelpMenuItem",
  SupportHelpMenuItems                                                   : "SupportHelpMenuItems",
  SupportHelpMenuItemsFeatured                                           : "GetFeaturedSupportHelpMenuItems",
  SystemLocks                                                            : "SystemLocks",
  SystemLocksEntityIsLocked                                              : "EntityIsLocked",
  SystemLocksRemoveAllUserSystemLocks                                    : "RemoveAllUserSystemLocks",
  TariffsRental                                                          : "TariffsRental",
  TariffsRentalBands                                                     : "TariffsRentalBands",
  TariffsRentalDetails                                                   : "TariffsRentalDetails",
  TariffsRentalDetailsGetTariffsRentalDetails                            : "GetTariffsRentalDetails",
  TariffsRentalGetTariffsRental                                          : "GetTariffsRental",
  TariffsUsage                                                           : "TariffsUsage",
  TariffsUsageGetTariffsUsage                                            : "GetTariffsUsage",
  TariffsUsageSchemeRateGetTariffUsageSchemeRates                        : "GetTariffUsageSchemeRates",
  TariffsUsageSchemeRates                                                : "TariffsUsageSchemeRate",
  TariffsUsageSchemes                                                    : "TariffsUsageScheme",
  TariffsUsageSchemesGetTariffsUsageSchemes                              : "GetTariffsUsageSchemes",
  TariffsUsageZones                                                      : "TariffsUsageZones",
  TariffsUsageZonesGetTariffsUsageZones                                  : "GetTariffsUsageZones",
  TeamsCallRecords                                                       : "TeamsCallRecords",
  TeamsCallRecordsServerSide                                             : "GetTeamsCallRecordsServerSide",
  TeamsMeta                                                              : "TeamsMeta",
  TeamsMetaGetCallsForDate                                               : "GetCallsForDate",
  TeamsMetaGetCallsForYesterday                                          : "GetCallsForYesterday",
  TeamsPresenceMeta                                                      : "TeamsPresenceMeta",
  TeamsPresenceMetaCreatePresenceSubscriptionsManual                     : "CreatePresenceSubscriptionsManual",
  TeamsPresenceMetaGetCurrentPresences                                   : "GetCurrentPresences",
  TeamsPresenceMetaGetPresenceStats                                      : "GetPresenceStats",
  TeamsPresenceMetaReconcilePresencesManual                              : "ReconcilePresencesManual",
  TeamsPresenceMetaRenewPresenceSubscriptionsManual                      : "RenewPresenceSubscriptionsManual",
  TeamsPresenceRecords                                                   : "TeamsPresenceRecords",
  TeamsPresenceRecordsServerSide                                         : "GetTeamsPresenceRecordsServerSide",
  TicketPost                                                             : "PostTicket",
  TicketPut                                                              : "PutTicket",
  Tickets                                                                : "Tickets",
  Tools                                                                  : "Tools",
  ToolsApiIsAlive                                                        : "ApiIsAlive",
  TypesAccess                                                            : "TypesAccess",
  TypesAlert                                                             : "TypesAlert",
  TypesAudit                                                             : "TypesAudit",
  TypesBillingService                                                    : "TypesBillingService",
  TypesBrand                                                             : "TypesBrand",
  TypesCharge                                                            : "TypesCharge",
  TypesCommunication                                                     : "TypesCommunication",
  TypesCommunicationDeliveryStatus                                       : "TypesCommunicationDeliveryStatus",
  TypesCompany                                                           : "TypesCompany",
  TypesCompanyFile                                                       : "TypesCompanyFile",
  TypesCurrency                                                          : "TypesCurrency",
  TypesCurrencySymbol                                                    : "TypesCurrencySymbol",
  TypesDataWeight                                                        : "TypesDataWeight",
  TypesDelivery                                                          : "TypesDelivery",
  TypesDevice                                                            : "TypesDevice",
  TypesDownloadFile                                                      : "TypesDownloadFile",
  TypesLanguage                                                          : "TypesLanguage",
  TypesLicence                                                           : "TypesLicence",
  TypesLicenceCalculateCancellationDateForNewLicence                     : "CalculateCancellationDateForNewLicence",
  TypesLicenceCalculateStartDateForNewLicence                            : "CalculateStartDateForNewLicence",
  TypesManufacturer                                                      : "TypesManufacturer",
  TypesMdmComplianceIssue                                                : "TypesMdmComplianceIssue",
  TypesMdmDevice                                                         : "TypesMdmDevice",
  TypesMdmDeviceEndOfLifeSource                                          : "TypesMdmDeviceEndOfLifeSource",
  TypesMdmDeviceEndOfSupportSource                                       : "TypesMdmDeviceEndOfSupportSource",
  TypesMdmStatus                                                         : "TypesMdmStatus",
  TypesMessage                                                           : "TypesMessage",
  TypesOccupation                                                        : "TypesOccupation",
  TypesOrderStatus                                                       : "TypesOrderStatus",
  TypesPayment                                                           : "TypesPayment",
  TypesPaymentTerm                                                       : "TypesPaymentTerm",
  TypesPortal                                                            : "TypesPortal",
  TypesRecurring                                                         : "TypesRecurring",
  TypesRounding                                                          : "TypesRounding",
  TypesSupportPlan                                                       : "TypesSupportPlan",
  TypesTariff                                                            : "TypesTariff",
  TypesTariffBandLevel                                                   : "TypesTariffBandLevel",
  TypesThrottleSpeed                                                     : "TypesThrottleSpeed",
  TypesTicketIssue                                                       : "TypesTicketIssue",
  TypesTicketPriority                                                    : "TypesTicketPriority",
  TypesUserLink                                                          : "TypesUserLink",
  TypesWebhook                                                           : "TypesWebhook",
  UserBrowserInfo                                                        : "UserBrowserInfo",
  UserClientInfo                                                         : "UserClientInfo",
  UserGroups                                                             : "UserGroups",
  UserGroupsAddUserToGroup                                               : "AddUserToGroup",
  UserGroupsDeleteUserAllocation                                         : "DeleteUserAllocation",
  UserGroupsDeleteUserGroup                                              : "DeleteUserGroup",
  UserGroupsGetAllGroupsForAlertId                                       : "GetAllGroupsForAlert",
  UserGroupsGetAllGroupsForUser                                          : "GetAllGroupsForUser",
  UserGroupsGetAllUsersForGroupId                                        : "GetAllUsersForGroupId",
  UserGroupsGetUserGroupAllocationForCompany                             : "GetUserGroupAllocationForCompany",
  UserGroupsGetUserGroupById                                             : "GetUserGroupById",
  UserGroupsGetUserGroupByUserId                                         : "GetUserGroupByUserId",
  UserGroupsGetUserGroupsForCompany                                      : "GetUserGroupsForCompany",
  UserGroupsGetUserGroupsForUser                                         : "GetUserGroupsForUser",
  UserGroupsPost                                                         : "PostUserGroup",
  UserGroupsPut                                                          : "PutUserGroup",
  UserGroupsRemoveUserFromGroup                                          : "RemoveUserFromGroup",
  Users                                                                  : "Users",
  UsersChannelAvailabilityForHierarchy                                   : "CommunicationChannelAvailabilityForHierarchy",
  UserSessions                                                           : "UserSessions",
  UserSessionsGetStats                                                   : "GetStats",
  UserSessionsServerSide                                                 : "GetUserSessionsServerSide",
  UsersForHierarchy                                                      : "UsersForHierarchy",
  UsersGetCompanyId                                                      : "GetCompanyId",
  UsersGetUsersForCompany                                                : "GetUsersForCompany",
  UsersGetUsersForCompanyIncAssociates                                   : "GetUsersForCompanyIncAssociates",
  UsersGetUsersWithUnresolvedMobile                                      : "GetUsersWithUnresolvedMobile",
  UsersMobileExistsOnDifferentUser                                       : "MobileExistsOnDifferentUser",
  UsersNormaliseMobileNumbers                                            : "NormaliseMobileNumbers",
  UsersKillUser                                                          : "KillUser",
  UsersRepairMalformedMobileE164                                         : "RepairMalformedMobileE164",
  UsersTotp                                                              : "UsersTotp",
  UsersTotpBegin                                                         : "Begin",
  UsersTotpConfirm                                                       : "Confirm",
  UsersTotpReset2Fa                                                      : "Reset2Fa",
  UsersTotpVerifyLogin                                                   : "VerifyLogin",
  UsersTotpVerifyRecovery                                                : "VerifyRecovery",
  UsersTransferUser                                                      : "TransferUser",
  UsersTransferUserSimData                                               : "TransferUserSimData",
  UsersUndelete                                                          : "Undelete",
  UserTransfersSim                                                       : "UserTransfersSim",
  Webbing                                                                : "Webbing",
  WebbingBar                                                             : "BarSIM",
  WebbingBulkCreateUsersOnly                                             : "BulkCreateUsersOnly",
  WebbingBulkReserveSims                                                 : "BulkReserveSims",
  WebbingBulkUnreserveSims                                               : "BulkUnreserveSims",
  WebbingClearBulkErrors                                                 : "ClearBulkErrors",
  WebbingSendManualActivationDetails                                     : "SendManualActivationDetails",
  WebbingDeprovision                                                     : "Deprovision",
  WebbingEnable                                                          : "ActivateServiceDevice",
  WebbingGetCompanySIMLocations                                          : "GetCompanySIMLocations",
  WebbingGetESIMEventLogs                                                : "GetESIMEventLogs",
  WebbingGetESIMLog                                                      : "GetESIMLog",
  WebbingGetESIMLogEventLog                                              : "GetESIMLogEventLog",
  WebbingGetESIMLogProfile                                               : "GetESIMLogProfile",
  WebbingGetLocation                                                     : "GetCurrentSIMLocation",
  WebbingGetNetworkEventsBySimAndDate                                    : "GetNetworkEventRecordsBySimAndDateRange",
  WebbingGetOnlineDeviceUsage                                            : "GetOnlineDeviceUsage",
  WebbingGetSDLiveData                                                   : "GetSDLiveData",
  WebbingGetSIMLocations                                                 : "GetSIMLocations",
  WebbingLimitChange                                                     : "SIMLimitChanged",
  WebbingLockImei                                                        : "SetImeiLock",
  WebbingProductsRefresh                                                 : "RefreshProducts",
  WebbingProvisionBulk                                                   : "BulkProvision",
  WebbingProvisionBulkInitialise                                         : "BulkProvisionInitialise",
  WebbingProvisionNextAvailableSim                                       : "ProvisionNextAvailableSIM",
  WebbingRemoveAlertProduct                                              : "RemoveAlertProductSim",
  WebbingReserveNextAvailableSim                                         : "ReserveNextAvailableSIM",
  WebbingResetNetwork                                                    : "ResetNetwork",
  WebbingSetProduct                                                      : "ChangeServiceDeviceProduct",
  WebbingStopProvisionBulk                                               : "StopBulkProvisioning",
  WebbingSuspend                                                         : "SuspendServiceDevice",
  WebbingThrottle                                                        : "ThrottleEsim",
  WebbingUnbar                                                           : "UnBarSIM",
  WebbingUnreserveSim                                                    : "UnreserveSim",    
  WebbingUnthrottle                                                      : "UnThrottleEsim",
  WebbingUpdateInviewToMatch                                             : "BulkUpdateInviewToMatch",
  WebComponentContainers                                                 : "WebComponentContainers",
  WebComponents                                                          : "WebComponents",
  WebComponentsGetWebComponentsChargeable                                : "GetWebComponentsChargeable",
  WebhookLog                                                             : "WebhookLog",
  WebhookLogForCompany                                                   : "ForCompany",
  Widgets                                                                : "Widgets",
  WidgetsGetApplicationDetails                                           : "GetApplicationDetails",
  WidgetsGetApplicationSummary                                           : "GetApplicationSummary",
  WidgetsGetCompanyDetails                                               : "GetCompanyDetails",
  WidgetsGetCompanyTotalCost                                             : "GetCompanyTotalCost",
  WidgetsGetCompanyTotalUsage                                            : "GetCompanyTotalUsage",
  WidgetsGetCompliance_Jailbroken                                        : "GetCompliance_Jailbroken",
  WidgetsGetCompliance_PinCode                                           : "GetCompliance_PinCode",
  WidgetsGetCompliance_Software                                          : "GetCompliance_Software",
  WidgetsGetCountryDetails                                               : "GetCountryDetails",
  WidgetsGetCompanyAlertsBreakdown                                       : "GetCompanyAlertsBreakdown",
  WidgetsGetCompanyBundleDetails                                         : "GetCompanyBundleDetails",
  WidgetsGetCompanyCostsBreakdown                                        : "GetCompanyCostsBreakdown",
  WidgetsGetCompanyDataBundleUsage                                       : "GetCompanyDataBundleUsage",
  WidgetsGetCompanyLatestCountryUsageSummary                             : "GetCompanyLatestCountryUsageSummary",
  WidgetsGetCompanyLicenceSummary                                        : "GetCompanyLicenceSummary",
  WidgetsGetCompanySMSAllowance                                          : "GetCompanySMSAllowance",
  WidgetsGetCompanyTimeline                                              : "GetCompanyTimeline",
  WidgetsGetCountryUsageSummary                                          : "GetCountryUsageSummary",
  WidgetsGetZoneUsageBundleSummary                                       : "GetZoneUsageBundleSummary",
  WidgetsGetZoneUsageSummary                                             : "GetZoneUsageSummary",
  WidgetsGetIccidTotalCost                                               : "GetIccidTotalCost",
  WidgetsGetIccidTotalUsage                                              : "GetIccidTotalUsage",
  WidgetsGetIntuneDevicesAverageAge                                      : "GetIntuneDevicesAverageAge",
  WidgetsGetIntuneDevicesByCarrier                                       : "GetIntuneDevicesByCarrier",
  WidgetsGetIntuneDevicesByCompanyManaged                                : "GetIntuneDevicesByCompanyManaged",
  WidgetsGetIntuneDevicesByEncrypted                                     : "GetIntuneDevicesByEncrypted",
  WidgetsGetIntuneDevicesByJailbroken                                    : "GetIntuneDevicesByJailbroken",
  WidgetsGetIntuneDevicesByManagementState                               : "GetIntuneDevicesByManagementState",
  WidgetsGetIntuneDevicesByManufacturer                                  : "GetIntuneDevicesByManufacturer",
  WidgetsGetIntuneDevicesByOperatingSystem                               : "GetIntuneDevicesByOperatingSystem",
  WidgetsGetIntuneDevicesByOperatingSystemCompliant_Intune               : "GetIntuneDevicesByOperatingSystemCompliant_Intune",
  WidgetsGetIntuneDevicesByOperatingSystemCompliant_Ours                 : "GetIntuneDevicesByOperatingSystemCompliant_Ours",
  WidgetsGetIntuneDevicesByOperatingSystemCompliant_OursMinor            : "GetIntuneDevicesByOperatingSystemCompliant_OursMinor",
  WidgetsGetIntuneDevicesBySupervised                                    : "GetIntuneDevicesBySupervised",
  WidgetsGetIntuneDevicesCheckedInLast30Days                             : "GetIntuneDevicesCheckedInLast30Days",
  WidgetsGetIntuneDevicesEndOfLife                                       : "GetIntuneDevicesEndOfLife",
  WidgetsGetIntuneDevicesEndOfLifePerYearCount                           : "GetIntuneDevicesEndOfLifePerYearCount",
  WidgetsGetIntuneDevicesLess_X_GbRemaining                              : "GetIntuneDevicesLess_X_GbRemaining",
  WidgetsGetIntuneDevicesNotCheckedInLast30Days                          : "GetIntuneDevicesNotCheckedInLast30Days",
  WidgetsGetIntuneDevicesNotSupported                                    : "GetIntuneDevicesNotSupported",
  WidgetsGetIntuneDevicesNotSupportedEOS                                 : "GetIntuneDevicesNotSupportedEOS",
  WidgetsGetIntuneDevicesOldest                                          : "GetIntuneDevicesOldest",
  WidgetsGetIntuneDevicesSupported                                       : "GetIntuneDevicesSupported",
  WidgetsGetIntuneDevicesSupportedEOS                                    : "GetIntuneDevicesSupportedEOS",
  WidgetsGetIntuneDevicesTotalCount                                      : "GetIntuneDevicesTotalCount",
  WidgetsGetIntuneDevicesTotalNew                                        : "GetIntuneDevicesTotalNew",
  WidgetsGetIntuneDevicesWithMoreThanOneRegistration                     : "GetIntuneDevicesWithMoreThanOneRegistration",
  WidgetsGetIntuneDevicesXYearsOrOver                                    : "GetIntuneDevicesXYearsOrOver",
  WidgetsGetIntuneDeviceVolumeAndHealthTrend                             : "GetIntuneDeviceVolumeAndHealthTrend",
  WidgetsGetIntuneUsersWithMoreThanOneDevice                             : "GetIntuneUsersWithMoreThanOneDevice",
  WidgetsGetIntuneUsersWithMoreThanOneDeviceSameType                     : "GetIntuneUsersWithMoreThanOneDeviceSameType",
  WidgetsGetLastestAndroid                                               : "GetLastestAndroid",
  WidgetsGetLastestIos                                                   : "GetLastestIos",
  WidgetsGetLiveTimeline                                                 : "GetLiveTimeline",
  WidgetsGetSimActivity                                                  : "GetSimActivity",
  WidgetsGetSimNotInactiveTotal                                          : "GetSimNotInactiveTotal",
  WidgetsGetTotalUsageAndLicenceCosts                                    : "GetTotalUsageAndLicenceCosts",
  WidgetsLiveTimelineHub                                                 : "livetimelineHub",
  WorldMaps                                                              : "WorldMaps",
  WorldZones                                                             : "WorldZones",
}

export const dropdownSelectAllValues = {
  AlertDefaultTemplate: "-- Blank --",
  All                 : "-- All --",
  Company             : "-- All Companies --",
  Device              : "-- All SIMs --",
  User                : "-- All Users --",
}

export const FlatpickrFormat = {
  Day_Month_Year             : "d/m/Y",
  Day_MonthWordFull_Year     : "j F, Y",
  Day_MonthWordFull_Year_Time: "j F, Y H:i",
  MonthWordFull_Day_Year     : "F j, Y",
  MonthWordFull_Year         : "F Y",
}

export const GridViewTitles={
  accountManagers                       : "Account Managers",
  alertDetails                          : "Alert Details",
  commConfig                            : "Comm Config",
  communication                         : "Communication",
  companies                             : "Companies",
  configAddresses                       : "Addresses",
  configCountries                       : "Countries",
  configCountryGroups                   : "Country Groups",
  configLicencesCompanyAllocated        : "Company Allocated Licences",
  configLicencesCompanyVisible          : "Company Visible Licences",
  configLicencesSystem                  : "System Licences",
  configMappedCountries                 : "Mapped Countries",
  configMappedZones                     : "Mapped Zones",
  configProducts                        : "Products",
  configReports                         : "Reports",
  configScreenDefaultsBase              : "Base Wide",
  configScreenDefaultsCompany           : "Company Type",
  configScreenDefaultsCompanyActual     : "Company",
  configScreenDefaultsUser              : "User Type",
  configScreenDefaultsUserActual        : "User",
  configSystem                          : "System Configuration",
  configTypesAccess                     : "User Roles",
  configTypesAudit                      : "Audit Types",
  configTypesBillingService             : "Billing Services",
  configTypesBrand                      : "Brands",
  configTypesCharge                     : "Charge Types",
  configTypesCommunication              : "Communication Types",
  configTypesCommunicationDeliveryStatus: "Communication Delivery Statuses",
  configTypesCompany                    : "Company Types",
  configTypesCompanyFile                : "Company File Types",
  configTypesCurrency                   : "Currency Types",
  configTypesCurrencySymbol             : "Currency Symbols",
  configTypesDataWeight                 : "Data Weights",
  configTypesDelivery                   : "Delivery Types",
  configTypesDevice                     : "Device Types",
  configTypesDownloadFile               : "Download File Types",
  configTypesLanguage                   : "Languages",
  configTypesLicence                    : "Licence Types",
  configTypesManufacturer               : "Manufacturers",
  configTypesMdmComplianceIssue         : "MDM Compliance Issue Types",
  configTypesMdmDevice                  : "MDM Device Types",
  configTypesMdmDeviceEndOfLifeSource   : "Device EOL Source Types",
  configTypesMdmDeviceEndOfSupportSource: "Device EOS Source Types",
  configTypesMdmStatus                  : "MDM Status Types",
  configTypesMessage                    : "Message Types",
  configTypesOccupation                 : "Occupations",
  configTypesOrderStatus                : "Order Statuses",
  configTypesPayment                    : "Payment Methods",
  configTypesPaymentTerm                : "Payment Terms",
  configTypesPortal                     : "Portal Types",
  configTypesRecurring                  : "Recurring Types",
  configTypesRounding                   : "Rounding Types",
  configTypesSupportPlan                : "Support Plans",
  configTypesTariff                     : "Tariff Types",
  configTypesTariffBandLevel            : "Tariff Band Levels",
  configTypesTicketIssue                : "Ticket Issue Types",
  configTypesTicketPriority             : "Ticket Priority",
  configTypesUserLink                   : "User Link Types",
  configTypesWebhook                    : "Webhook Types",
  configWorldMaps                       : "World Maps",
  configWorldZones                      : "World Zones",
  devicesAllocatedContentShared         : "Manage SIMs",
  devicesAvailable                      : "Available SIMs",
  eSimOrdersHistoric                    : "Provision History",
  eSimProvision                         : "SureSIM Provision",
  eSimReservation                       : "SureSIM Reservation",
  eSimTimeLine                          : "SIM Timeline",
  inventory                             : "Inventory Management",
  inventoryAssetRegister                : "Asset Register",
  manageTickets                         : "Support Tickets",
  mdmDashboard                          : "MDM Dashboard",
  mdmDeviceCompliance                   : "Cyber Essentials +",
  mdmDeviceComplianceCampaigns          : "MDM - Compliance Campaigns",
  mdmDeviceComplianceLogs               : "MDM - Compliance Campaign Logs",
  mdmDeviceNotificationLogs             : "MDM - Notification & Status Logs",
  mdmDeviceRemediation                  : "MDM Devices - Remediation",
  mdmDevices                            : "MDM Devices",
  mdmDevicesCompany                     : "MDM Devices - Company",
  mdmDevicesCompanyConfig               : "MDM - Company Config",
  mdmDevicesEndOfLife                   : "Devices End of Life",
  mdmDevicesIntune                      : "MDM Devices - All",
  mdmDevicesTemplatesCampaigns          : "MDM - Compliance Campaign Templates",
  mdmDevicesTemplatesRemediation        : "MDM - Remediation Templates",
  mdmDevicesTemplatesRemediationToStatus: "MDM - Remediation Templates to Statuses",
  mdmIntuneSimExceptions                : "Intune vs SureSIM Device Exceptions",
  mdmUsersIntune                        : "MDM Users",
  reportingFinancial                    : "Reports",
  signalsBreachExposure                 : "Breach Exposure",
  signalsCorporateHealth                : "Corporate Health",
  signalsDeviceVulnerabilities          : "Device Vulnerabilities",
  simProvisionBulkEmbedded              : "Bulk Provisioning",
  suppliers                             : "Suppliers",
  systemAdminApiManagement              : "API Management",
  systemAdminAudit                      : "Audit - System",
  systemAdminAuditErrorsOnly            : "Audit - System Errors",
  systemAdminCreditLimitAlertRecipients : "Credit Limit Alert Recipients",
  systemAdminCreditLimitManagement      : "Credit Limit Management",
  systemAdminOverview                   : "Admin Overview",
  systemAdminOverviewCustomer           : "Customer Overview",
  systemAdminOverviewSimStatuses        : "SIM Statuses",
  systemAdminPlatformInsights           : "Platform Insights",
  systemAdminSmsAudit                   : "Audit - SMS",
  systemAdminSystemLocks                : "System Locks",
  systemAdminTeams                      : "Teams Calls",
  systemAdminTeamsStatuses              : "Teams Statuses",
  systemAdminTransfersUserSim           : "User Transfers SIM",
  systemAdminTriggeredAlerts            : "Triggered Alerts",
  systemAdminUnresolvedMobile           : "Unresolved Mobile Numbers",
  systemAdminUserBrowserInfo            : "User Browser Info",
  systemAdminUserClientInfo             : "User Client Info",
  systemAdminUserSessions               : "User Sessions",
  tariffsRental                         : "Rental Tariffs",
  tariffsRentalBands                    : "Rental Tariff Bands",
  tariffsRentalDetails                  : "Rental Tariff Details",
  tariffsUsage                          : "Usage Tariffs",
  tariffsUsageSchemeRates               : "Usage Tariff Scheme Rates",
  tariffsUsageSchemes                   : "Usage Tariff Schemes",
  tariffsUsageZone                      : "Usage Tariff Zones",
  ticketsHub                            : "Support Tickets",
  userGroup                             : "User Groups",
  usersAssociate                        : "Associates",
  usersEsim                             : "SIM Subscribers",
  usersPortal                           : "Portal Users",
  webComponentContainers                : "Web Component Containers",
  webComponents                         : "Web Components",
  webhookLog                            : "Webhook Delivery Log",
}

//#region Inventory (Lucy)

export const InventoryStatusStyleDefault: { colour: string; icon: string; }={ colour: 'dark', icon: 'ri-checkbox-blank-circle-line' };

export const InventoryStatusStyles: Record<string, { colour: string; icon: string; }>={
  '1st call'                   : { colour: 'primary', icon: 'ri-customer-service-2-line' },
  'assigned'                   : { colour: 'info',    icon: 'ri-user-shared-line'        },
  'at technical centre'        : { colour: 'warning', icon: 'ri-tools-line'              },
  'in stock'                   : { colour: 'info',    icon: 'ri-archive-line'            },
  'in transit to customer'     : { colour: 'primary', icon: 'ri-truck-line'              },
  'in transit to depot'        : { colour: 'primary', icon: 'ri-arrow-go-back-line'      },
  'lost'                       : { colour: 'danger',  icon: 'ri-error-warning-line'      },
  'no status'                  : { colour: 'dark',    icon: 'ri-question-line'           },
  'retired'                    : { colour: 'danger',  icon: 'ri-inbox-archive-line'      },
  'warranty at 3rd party'      : { colour: 'success', icon: 'ri-shield-line'             },
  'warranty in-house'          : { colour: 'success', icon: 'ri-shield-check-line'       },
  'with user'                  : { colour: 'success', icon: 'ri-user-follow-line'        },
  'written off / lost / stolen': { colour: 'danger',  icon: 'ri-delete-bin-2-line'       },
};

export const InventoryStatusTileHidden: string[]=['1st call'];

export const InventoryStatusTileRows: string[][]=[
  ['with user', 'warranty in-house', 'warranty at 3rd party'],
  ['in stock', 'at technical centre', 'lost', 'retired', '1st call'],
];

//#endregion

export const modalFormValues = {
  createNewCompany   : "-- Create New Company --",
  createNewCompanyId : -100,
  createNewUser      : "-- Create New User --",
  createNewUserId    : -100,
  createTestCompany  : "-- Create Trial Account --",
  createTestCompanyId: -101,
}

//#region LimitChange

export const LimitChangeBarring = {
  Unknown      : 0,
  Barred       : 1,
  StillBarred  : 2,
  Unbarred     : 3,
  NoActionTaken: 4, 
}

//#endregion

export const MdmDeviceClass={
  mobile: "mobile",
  other : "other",
}

export const MdmUserDomainOther="_other";

//#region Modal Form

export const ModalForms = {
  Unknown: "Unknown",
  Company: "Company",
  User   : "User",
} as const;

export type ModalFormType=typeof ModalForms[keyof typeof ModalForms];

//#endregion

//#region Modal Service

export const msBackdrop = {
  False : false,
  Static: "static",
  True  : true,
}

export const msFullscreen = {
  Small     : "sm",
  Medium    : "md",
  Large     : "lg",
  ExtraLarge: "xl",
  XXLarge   : "xxl",
}

export const msSize = {
  Small     : "sm",
  Medium    : "md",
  Large     : "lg",
  ExtraLarge: "xl",
  FullScreen: "fullscreen",
} as const;

export type msSizeType=typeof msSize[keyof typeof msSize];

//#endregion

export const MdmDashboardWidgetTitles = {
  chart_DevicesEndOfLife                     : "chart_DevicesEndOfLife",
   
  device_AverageAge                          : "device_AverageAge",
  device_CheckedInLast30Days                 : "device_CheckedInLast30Days",
  device_MoreThanOneRegistration             : "device_MoreThanOneRegistration",
  device_NotCheckedInLast30Days              : "device_NotCheckedInLast30Days",
  device_NotSupported                        : "device_NotSupported",
  device_NotSupportedEOS                     : "device_NotSupportedEOS",
  device_Oldest                              : "device_Oldest",
  device_StorageRemaining                    : "device_StorageRemaining",
  device_Supported                           : "device_Supported",
  device_SupportedEOS                        : "device_SupportedEOS",
  device_TotalCount                          : "device_TotalCount",
  device_TotalNew                            : "device_TotalNew",
  device_XYearsOrOver                        : "device_XYearsOrOver",
   
  devicesByCarrier                           : "devicesByCarrierChart",
  devicesByCompanyManaged                    : "devicesByCompanyManagedChart",
  devicesByEncrypted                         : "devicesByEncryptedChart",
  devicesByJailbroken                        : "devicesByJailbrokenChart",
  devicesByManagementState                   : "devicesByManagementStateChart",
  devicesByManufacturer                      : "devicesByManufacturerChart",
  devicesByOperatingSystem                   : "devicesByOperatingSystemChart",
  devicesByOperatingSystemCompliant_Intune   : "devicesByOperatingSystemCompliant_IntuneChart",
  devicesByOperatingSystemCompliant_Ours     : "devicesByOperatingSystemCompliant_OursChart",
  devicesByOperatingSystemCompliant_OursMinor: "devicesByOperatingSystemCompliant_OursMinorChart",
  devicesBySupervised                        : "devicesBySupervisedChart",
     
  unknown                                    : "unknownChart",
     
  user_MoreThanOneDevice                     : "user_MoreThanOneDevice",
  user_MoreThanOneDeviceSameType             : "user_MoreThanOneDeviceSameType",
} as const;

export const MdmDashboardWidgetFriendlyTitles: Record<string, string> = {
  [MdmDashboardWidgetTitles.chart_DevicesEndOfLife]                     : "Devices End of Life",
   
  [MdmDashboardWidgetTitles.device_AverageAge]                          : "All Devices",
  [MdmDashboardWidgetTitles.device_CheckedInLast30Days]                 : "Checked-in (last 30 days)",
  [MdmDashboardWidgetTitles.device_MoreThanOneRegistration]             : "Devices (more than 1 registration)",
  [MdmDashboardWidgetTitles.device_NotCheckedInLast30Days]              : "Not Checked-in (last 30 days)",
  [MdmDashboardWidgetTitles.device_NotSupported]                        : "Not Supported Devices",
  [MdmDashboardWidgetTitles.device_NotSupportedEOS]                     : "Not Supported Devices (EOS)",
  [MdmDashboardWidgetTitles.device_Oldest]                              : "Oldest Device",
  [MdmDashboardWidgetTitles.device_StorageRemaining]                    : "Low Storage (less than 12 GB)",
  [MdmDashboardWidgetTitles.device_Supported]                           : "Supported Devices",
  [MdmDashboardWidgetTitles.device_SupportedEOS]                        : "Supported Devices (EOS)",
  [MdmDashboardWidgetTitles.device_TotalCount]                          : "Total Devices",
  [MdmDashboardWidgetTitles.device_TotalNew]                            : "New Devices (last 7 days)",
  [MdmDashboardWidgetTitles.device_XYearsOrOver]                        : "Devices (4 years or over)",
   
  [MdmDashboardWidgetTitles.devicesByCarrier]                           : "Devices by Carrier",
  [MdmDashboardWidgetTitles.devicesByCompanyManaged]                    : "Managed by",
  [MdmDashboardWidgetTitles.devicesByEncrypted]                         : "Devices by Encryption",
  [MdmDashboardWidgetTitles.devicesByJailbroken]                        : "Devices by Jailbreak Status",
  [MdmDashboardWidgetTitles.devicesByManagementState]                   : "Devices by Management State",
  [MdmDashboardWidgetTitles.devicesByManufacturer]                      : "Devices by Manufacturer",
  [MdmDashboardWidgetTitles.devicesByOperatingSystem]                   : "Devices by Operating System",
  [MdmDashboardWidgetTitles.devicesByOperatingSystemCompliant_Intune]   : "OS Compliance (MDM)",
  [MdmDashboardWidgetTitles.devicesByOperatingSystemCompliant_Ours]     : "OS Compliance (Latest Major OS)",
  [MdmDashboardWidgetTitles.devicesByOperatingSystemCompliant_OursMinor]: "OS Compliance (Latest Minor OS)",
  [MdmDashboardWidgetTitles.devicesBySupervised]                        : "Devices by Supervision",
     
  [MdmDashboardWidgetTitles.user_MoreThanOneDevice]                     : "Users (more than 1 device of any type)",
  [MdmDashboardWidgetTitles.user_MoreThanOneDeviceSameType]             : "Users (more than 1 device of the same type)",
};

export const MdmDeviceEndOfLifeNotSet={
  ChartLabel: "No EOL Date Set",
  Year      : 0,
} as const;

export const MobileOperatingSystems = {
  android: "Android",
  iOS    : "iOS",
  unknown: "Unknown",
} as const;

export type MobileOperatingSystem=typeof MobileOperatingSystems[keyof typeof MobileOperatingSystems];

export const OurColors = {
  Black    : "#000000",
  DarkBlue : "#405189",
  Green    : "#0AB39C",
  LightGrey: "#ECEEF3",
  LightRed : "#FDE2E2",
  Red      : "#CC0000",
}

export const OurCompany = {
  CompanyNameFull    : "SureSIM Global",
  CompanyNamePascal  : "SureSIM",
  CompanyNamePlatform: "Inview",
  CompanyNameUpper   : "SURESIM",
  Domain             : "utelize.co.uk",
  SureSimIoDomain    : "SureSim.io",
  SystemAdminEmail   : "cnorwood@utelize.co.uk",
  SystemAdminEmail1  : "iatkins@utelize.co.uk",
  SystemAdminEmail2  : "rwilliams@utelize.co.uk",
}

//#region Pages Content Shared - HostsOfSharedComponents

export const Hosts_DevicesAllocatedContentSharedComponent={
  DashboardComponent           : "DashboardComponent",
  DevicesAllocatedComponent    : "DevicesAllocatedComponent",
  TravelRiskManagementComponent: "TravelRiskManagementComponent",
  UsageDashboardComponent      : "UsageDashboardComponent",
}

//#endregion

export const Prefixes = {
  SystemError: "System.Exception:",
}

export const Sso = {
  Microsoft_LoginRoot      : "https://login.microsoftonline.com/",
  Microsoft_RedirectRoute  : "auth-redirect",
  Microsoft_TenantId_Common: "common",
}

export const StorageValues = {
  encAuthUser                       : "encAuthUser",
  encClockBarDismissed_             : "encClockBarDismissed_",
  encClockIconZones_                : "encClockIconZones_",
  encCurrentUser                    : "encCurrentUser",
  encDemoMode_                      : "encDemoMode_",
  encPWord                          : "encPWord",
  encForceLogout                    : "encForceLogout",
  encInitialLogin                   : "encInitialLogin",
  encLockRoute                      : "encLockRoute",
  encLoginCookieWarningSuppress     : "encLoginCookieWarningSuppress",
  encSessionEnded                   : "encSessionEnded",
  encSsoLoggedIn                    : "encSsoLoggedIn",
  encSsoRedirect                    : "encSsoRedirect",
  encSsoTenantId                    : "encSsoTenantId",
  encSsoToken                       : "encSsoToken",
  encSsoUsername                    : "encSsoUsername",
  encLoginTitleSet                  : "encLoginTitleSet",
  encTempCurrentUser                : "encTempCurrentUser",
  encToken                          : "encToken",
  encTotpAuthenticated              : "encTotpAuthenticated",
  encTotpRequired                   : "encTotpRequired",
  encUsers                          : "encUsers",
  msalInteractionStatus             : "msal.interaction.status",
  msCustomTenantLogin               : "customTenantLogin",
  sureSimAllocatedStatsHidden_      : "SureSimAllocatedStatsHidden_",
  sureSimAssistantAuditLog          : "SureSimAssistantAuditLog",
  sureSimAssistantAuditLog_         : "SureSimAssistantAuditLog_",
  sureSimAssistantPinnedActionConfig: "SureSimAssistantPinnedActionConfig",
  sureSimAssistantPinnedActions_    : "SureSimAssistantPinnedActions_",
  sureSimAssistantPrefs_            : "SureSimAssistantPrefs_",
  sureSimAssistantTimeline_         : "SureSimAssistantTimeline_",
  sureSimAuditStatsHidden_          : "SureSimAuditStatsHidden_",
  sureSimDialCodePins_              : "SureSimDialCodePins_",
  sureSimRiskIntelStatsHidden_      : "SureSimRiskIntelStatsHidden_",
  sureSimRiskIntelStatsPinned_      : "SureSimRiskIntelStatsPinned_",
  sureSimSignalsStatsHidden_        : "SureSimSignalsStatsHidden_",
  sureSimStatementMenuKeepOpen_     : "SureSimStatementMenuKeepOpen_",
  sureSimTeamsStatusesChartsHidden_ : "SureSimTeamsStatusesChartsHidden_",
  sureSimTeamsStatusesWidgetsHidden_: "SureSimTeamsStatusesWidgetsHidden_",
  sureSimUserSessionsStatsHidden_   : "SureSimUserSessionsStatsHidden_",
}

export const SystemLocks = {
  Company         : "Company",
  DummyOrderLockId: -100,
  Licence         : "Licence",
  User            : "User",
}

//#region Toast

export const ToastMessage = {
  HttpFailureResponseFor       : "Http failure response for",
  ProductsRefreshedSuccessfully: "Products Refreshed Successfully!!!",
  ProductsRefreshFailed        : "Products Refresh Failed!!!",
  ProcessCannotContinue        : "Process cannot continue",
  SecurityTokenSessionEnd      : "The current session has ended",
  System_AccountLocked         : "Login Account is Locked",
  System_UnableToChangePassword: "Unable to change the password",
  System_UnableToLogin         : "Unable to Login to",
  System_UnableToResetPassword : "Unable to reset the password",
  System_WelcomeToThe          : "Welcome to the",
}

export const ToastShowDelay = {
  Danger : 5000,
  Success: 5000,
}

//#endregion

export const TrmContainers={
  allocatedSims  : "allocatedSims",
  map            : "map",
  messageActivity: "messageActivity",
  panels         : "panels",
}

export const TrmContainerTitles={
  allocatedSims  : "Allocated SIMs",
  map            : "Traveller Location Awareness",
  messageActivity: "Message & Briefing Activity",
  panels         : "Travel Risk Feeds",
}

export const WriteToTemplateDelay = {
  Short   : 100,
  Medium  : 500,
  Long    : 1000,
  Daft    : 5000,
  FiveMins: 300000,
}

//#region Types

export const StatementLogoAcceptTypes="image/png,image/jpeg";

export const TypeAccess={
  Administrator  : "Administrator",
  CustomerService: "Customer Service",
  Finance        : "Finance",
  NoAccess       : "No Access",
  OutOfHoursTeam : "Out of Hours Team",
  Provisioning   : "Provisioning",
  SuperUser      : "Super User",
}

export const TypeCommunication={
  Unknown : "Unknown",
  Alert   : "Alert",
  All     : "All",
  Message : "Message",
}

export const TypeCommunicationDeliveryStatus={
  Unknown  : "Unknown",
  Delivered: "Delivered",
  Failed   : "Failed",
  Pending  : "Pending",
  Read     : "Read",
  Sent     : "Sent",
}

export const TypeCompany={
  Customer            : "Customer",
  Distributor         : "Distributor",
  ResellerCommissioned: "Reseller - Commissioned",
  ResellerWholesale   : "Reseller - Wholesale",
  SystemOwner         : "System Owner",
}

export const TypeCompanyFile={
  Unknown      : "Unknown",
  Logo         : "Logo",
  StatementLogo: "StatementLogo",
}

export const TypeDelivery={
  Email       : "Email",        //ORD 1
  InApp       : "In-App",       //ORD 4
  Notification: "Notification", //ORD 2
  SMS         : "SMS",          //ORD 3
}

export const TypeDevice={
  eSIM: "eSIM",
  SIM : "SIM",
}

export const TypeDeviceInt={
  eSIM: 1,
  SIM : 2,
}

export const TypeLicence={
  Unknown   : "Unknown",
  Bundle    : "Bundle",
  Feature   : "Feature",
  Platform  : "Platform",
  PoolBundle: "Pool Bundle",
  Usage     : "Rate",
}

export const TypeLicenceStatus={
  Unknown         : "Unknown",
  AboutToEnd      : "About to End",
  CurrentlyBilling: "Currently Billing",
  EndedLicence    : "Ended Licence",
  YetToBill       : "Yet to Bill",
}

//CRN_20260520 - Other EspTypesMessage values stay backend for now
export const TypeMessage={
  UserComposedCommunication: "User Composed Communication",
}

export const TypeOccupation={
  NotKnown       : "--- Not Known ---",
  PreferNotToSay : "--- Prefer not to say ---",
  Unknown        : "Unknown",
}

export const TypeProgressInformation={
  Unknown    : "Unknown",
  Error      : "Error",
  Event      : "Event",
  Information: "Information",
  Warning    : "Warning",
}

//#endregion

//#region Widgets

export const WidgetGroupKeys={
  totalAlerts        : "TotalAlerts",
  totalCosts         : "TotalCosts",
  totalLicences      : "TotalLicences",
  totalSimsUsageCosts: "TotalSimsUsageCosts",
} as const;

export type SelectorItemWidgetGroupKeyType=typeof WidgetGroupKeys[keyof typeof WidgetGroupKeys];

export const WidgetTitles={
  alertsTimesTriggeredCountry             : "<span class='stat-title-sub'>TOTAL</span><br>COUNTRY<br><span class='stat-title-sub'>ALERTS</span>",
  alertsTimesTriggeredUsage               : "<span class='stat-title-sub'>TOTAL</span><br>USAGE<br><span class='stat-title-sub'>ALERTS</span>",
  alertsTotalLimitIncreases               : "<span class='stat-title-sub'>TOTAL</span><br>LIMIT INCREASE<br><span class='stat-title-sub'>ALERTS</span>",
  alertsTotalThrottles                    : "<span class='stat-title-sub'>TOTAL</span><br>THROTTLE<br><span class='stat-title-sub'>ALERTS</span>",
  //CRN_20261013 - Moved to app-stat-tile
  //intuneDevicesAverageAge                 : "<span class='stat-title-sub'>AVERAGE AGE (MONTHS)</span><br>DEVICES<br><span class='stat-title-sub'>BASED ON ENROLLED DATE</span>",
  //intuneDevicesCheckedInLast30Days        : "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>CHECK-IN (30 DAYS)</span>",
  //intuneDevicesLess_X_GbRemaining         : "<span class='stat-title-sub'>STORAGE REMAINING</span><br>DEVICES<br><span class='stat-title-sub'>LESS THAN 12GB</span>",
  //intuneDevicesNotCheckedInLast30Days     : "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>NO CHECK-IN (30 DAYS)</span>",
  //intuneDevicesNotSupported               : "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>NOT SUPPORTED (EOL)</span>",
  //intuneDevicesNotSupportedEOS            : "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>NOT SUPPORTED (EOS)</span>",
  //intuneDevicesOldest                     : "<span class='stat-title-sub'>OLDEST</span><br>DEVICE<br><span class='stat-title-sub'>BASED ON ENROLLED DATE</span>",
  //intuneDevicesSupported                  : "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>SUPPORTED (EOL)</span>",
  //intuneDevicesSupportedEOS               : "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>SUPPORTED (EOS)</span>",
  //intuneDevicesTotalCount                 : "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>In MDM</span>",
  //intuneDevicesTotalNew                   : "<span class='stat-title-sub'>TOTAL</span><br>NEW DEVICES<br><span class='stat-title-sub'>ENROLLED LAST 7 DAYS</span>",
  //intuneDevicesWithMoreThanOneRegistration: "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>MORE THAN 1</span>",
  //intuneDevicesXYearsOrOver               : "<span class='stat-title-sub'>TOTAL</span><br>DEVICES<br><span class='stat-title-sub'>OVER 4 YEARS OLD</span>",
  //intuneUsersWithMoreThanOneDevice        : "<span class='stat-title-sub'>TOTAL</span><br>USERS<br><span class='stat-title-sub'>MORE THAN 1</span>",
  //intuneUsersWithMoreThanOneDeviceSameType: "<span class='stat-title-sub'>TOTAL</span><br>USERS<br><span class='stat-title-sub'>MORE THAN 1</span>",
  mdmDeviceComplianceCompanyDetails       : "TENANT",
  mdmDeviceComplianceJailbroken           : "JAILBROKEN",
  mdmDeviceComplianceLatestAndroid        : "LATEST ANDROID",
  mdmDeviceComplianceLatestIos            : "LATEST iOS",
  mdmDeviceCompliancePinCode              : "PIN CODE",
  mdmDeviceComplianceSoftwareAndroid      : "ANDROID",
  mdmDeviceComplianceSoftwareIos          : "IOS",
  mdmDeviceComplianceTotalDevices         : "TOTAL DEVICES",
  platformLicencesEndedLive               : "<span class='stat-title-sub'>ALLOCATED</span><br>DEVICE LICENCES<br><span class='stat-title-sub'>SET TO END</span>",
  //CRN_20261013 - Moved to app-stat-tile
  //totalAvailableEsims                     : "<span class='stat-title-sub'>TOTAL</span><br>AVAILABLE ESIMS",
  //totalAvailablePhysicalSims              : "<span class='stat-title-sub'>TOTAL</span><br>AVAILABLE PHYSICAL SIMS",
  totalCompanies                          : "<span class='stat-title-sub'>TOTAL</span><br>COMPANIES",
  totalCostsLicence                       : "<span class='stat-title-sub'>TOTAL</span><br>LICENCE COSTS<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalCostsLicenceNotIncUsage            : "<span class='stat-title-sub'>TOTAL</span><br>LICENCE COSTS<br><span class='stat-title-sub'>NOT INC USAGE</span>",
  totalCostsUsage                         : "<span class='stat-title-sub'>TOTAL</span><br>USAGE COSTS<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalCostsUsageAndLicence               : "<span class='stat-title-sub'>TOTAL</span><br>USAGE & LICENCE COSTS<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalCostsUsageCustomer                 : "<span class='stat-title-sub'>TOTAL</span><br>USAGE CUSTOMER COSTS<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalCostsUsageNotIncLicences           : "<span class='stat-title-sub'>TOTAL</span><br>USAGE COSTS<br><span class='stat-title-sub'>NOT INC LICENCES</span>",
  totalPlatformLicences                   : "<span class='stat-title-sub'>TOTAL</span><br>DEVICE LICENCES<br><span class='stat-title-sub'>USED OR NOT</span>",
  totalProfitUsage                        : "<span class='stat-title-sub'>TOTAL</span><br>USAGE PROFIT<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalPurchaseCostsUsage                 : "<span class='stat-title-sub'>TOTAL</span><br>USAGE PURCHASE COSTS<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalReservedEsims                      : "<span class='stat-title-sub'>TOTAL</span><br>RESERVED ESIMS",
  //CRN_20261013 - Moved to app-stat-tile
  //totalReservedPhysicalSims               : "<span class='stat-title-sub'>TOTAL</span><br>RESERVED PHYSICAL SIMS",
  totalSimProfitLicencesCost              : "<span class='stat-title-sub'>TOTAL</span><br>LICENCE COSTS<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalSimProfitSimBuyCosts               : "<span class='stat-title-sub'>TOTAL</span><br>SIM BUY COSTS<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalSimProfitTotalProfit               : "<span class='stat-title-sub'>TOTAL</span><br>SIM PROFIT<br><span class='stat-title-sub'>DURING MONTH</span>",
  totalSims                               : "<span class='stat-title-sub'>TOTAL</span><br>LIVE SIMS",
  totalUsage                              : "<span class='stat-title-sub'>TOTAL</span><br>USAGE<br><span class='stat-title-sub'>DURING MONTH</span>",
  unusedPlatformLicences                  : "<span class='stat-title-sub'>UNALLOCATED</span><br>DEVICE LICENCES",
  usedPlatformLicences                    : "<span class='stat-title-sub'>ALLOCATED</span><br>DEVICE LICENCES",
}

//#endregion
